var cov_2bjjvvfkcg = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Select/Select.tsx",
      hash = "96d38ebefd6616fcd2841a7cecb1be0a83f6bd6e",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Select/Select.tsx",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 26
        },
        end: {
          line: 19,
          column: 82
        }
      },
      "1": {
        start: {
          line: 20,
          column: 23
        },
        end: {
          line: 20,
          column: 73
        }
      },
      "2": {
        start: {
          line: 21,
          column: 26
        },
        end: {
          line: 21,
          column: 82
        }
      },
      "3": {
        start: {
          line: 23,
          column: 17
        },
        end: {
          line: 23,
          column: 114
        }
      },
      "4": {
        start: {
          line: 23,
          column: 60
        },
        end: {
          line: 23,
          column: 114
        }
      },
      "5": {
        start: {
          line: 25,
          column: 21
        },
        end: {
          line: 40,
          column: 1
        }
      },
      "6": {
        start: {
          line: 33,
          column: 26
        },
        end: {
          line: 33,
          column: 27
        }
      },
      "7": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 92,
          column: 16
        }
      },
      "8": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 98,
          column: 5
        }
      },
      "9": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 100,
          column: 50
        }
      },
      "10": {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 101,
          column: 56
        }
      },
      "11": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 102,
          column: 54
        }
      },
      "12": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 103,
          column: 50
        }
      },
      "13": {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 105,
          column: 50
        }
      },
      "14": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 106,
          column: 50
        }
      },
      "15": {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 107,
          column: 50
        }
      },
      "16": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 108,
          column: 52
        }
      },
      "17": {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 109,
          column: 59
        }
      },
      "18": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 110,
          column: 54
        }
      },
      "19": {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 111,
          column: 50
        }
      },
      "20": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 112,
          column: 60
        }
      },
      "21": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 66
        }
      },
      "22": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 114,
          column: 58
        }
      },
      "23": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 115,
          column: 58
        }
      },
      "24": {
        start: {
          line: 116,
          column: 4
        },
        end: {
          line: 116,
          column: 64
        }
      },
      "25": {
        start: {
          line: 117,
          column: 4
        },
        end: {
          line: 117,
          column: 52
        }
      },
      "26": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 120,
          column: 48
        }
      },
      "27": {
        start: {
          line: 121,
          column: 4
        },
        end: {
          line: 121,
          column: 52
        }
      },
      "28": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 123,
          column: 52
        }
      },
      "29": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 126,
          column: 44
        }
      },
      "30": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 128,
          column: 24
        }
      },
      "31": {
        start: {
          line: 130,
          column: 4
        },
        end: {
          line: 130,
          column: 43
        }
      },
      "32": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 132,
          column: 26
        }
      },
      "33": {
        start: {
          line: 136,
          column: 4
        },
        end: {
          line: 136,
          column: 26
        }
      },
      "34": {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 140,
          column: 29
        }
      },
      "35": {
        start: {
          line: 141,
          column: 4
        },
        end: {
          line: 141,
          column: 23
        }
      },
      "36": {
        start: {
          line: 142,
          column: 26
        },
        end: {
          line: 142,
          column: 36
        }
      },
      "37": {
        start: {
          line: 143,
          column: 4
        },
        end: {
          line: 145,
          column: 5
        }
      },
      "38": {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 144,
          column: 57
        }
      },
      "39": {
        start: {
          line: 149,
          column: 4
        },
        end: {
          line: 149,
          column: 23
        }
      },
      "40": {
        start: {
          line: 150,
          column: 25
        },
        end: {
          line: 150,
          column: 35
        }
      },
      "41": {
        start: {
          line: 152,
          column: 4
        },
        end: {
          line: 161,
          column: 5
        }
      },
      "42": {
        start: {
          line: 153,
          column: 6
        },
        end: {
          line: 160,
          column: 7
        }
      },
      "43": {
        start: {
          line: 157,
          column: 8
        },
        end: {
          line: 159,
          column: 15
        }
      },
      "44": {
        start: {
          line: 158,
          column: 10
        },
        end: {
          line: 158,
          column: 22
        }
      },
      "45": {
        start: {
          line: 165,
          column: 4
        },
        end: {
          line: 165,
          column: 32
        }
      },
      "46": {
        start: {
          line: 166,
          column: 26
        },
        end: {
          line: 166,
          column: 36
        }
      },
      "47": {
        start: {
          line: 167,
          column: 4
        },
        end: {
          line: 169,
          column: 5
        }
      },
      "48": {
        start: {
          line: 168,
          column: 6
        },
        end: {
          line: 168,
          column: 59
        }
      },
      "49": {
        start: {
          line: 170,
          column: 4
        },
        end: {
          line: 170,
          column: 25
        }
      },
      "50": {
        start: {
          line: 174,
          column: 4
        },
        end: {
          line: 176,
          column: 5
        }
      },
      "51": {
        start: {
          line: 175,
          column: 6
        },
        end: {
          line: 175,
          column: 30
        }
      },
      "52": {
        start: {
          line: 177,
          column: 4
        },
        end: {
          line: 177,
          column: 27
        }
      },
      "53": {
        start: {
          line: 181,
          column: 18
        },
        end: {
          line: 181,
          column: 53
        }
      },
      "54": {
        start: {
          line: 182,
          column: 4
        },
        end: {
          line: 187,
          column: 7
        }
      },
      "55": {
        start: {
          line: 183,
          column: 6
        },
        end: {
          line: 187,
          column: 7
        }
      },
      "56": {
        start: {
          line: 184,
          column: 8
        },
        end: {
          line: 184,
          column: 28
        }
      },
      "57": {
        start: {
          line: 185,
          column: 13
        },
        end: {
          line: 187,
          column: 7
        }
      },
      "58": {
        start: {
          line: 186,
          column: 8
        },
        end: {
          line: 186,
          column: 29
        }
      },
      "59": {
        start: {
          line: 188,
          column: 4
        },
        end: {
          line: 188,
          column: 26
        }
      },
      "60": {
        start: {
          line: 192,
          column: 4
        },
        end: {
          line: 194,
          column: 5
        }
      },
      "61": {
        start: {
          line: 193,
          column: 6
        },
        end: {
          line: 193,
          column: 32
        }
      },
      "62": {
        start: {
          line: 195,
          column: 4
        },
        end: {
          line: 195,
          column: 32
        }
      },
      "63": {
        start: {
          line: 199,
          column: 39
        },
        end: {
          line: 199,
          column: 49
        }
      },
      "64": {
        start: {
          line: 200,
          column: 4
        },
        end: {
          line: 200,
          column: 29
        }
      },
      "65": {
        start: {
          line: 200,
          column: 17
        },
        end: {
          line: 200,
          column: 29
        }
      },
      "66": {
        start: {
          line: 201,
          column: 4
        },
        end: {
          line: 201,
          column: 24
        }
      },
      "67": {
        start: {
          line: 205,
          column: 4
        },
        end: {
          line: 205,
          column: 24
        }
      },
      "68": {
        start: {
          line: 209,
          column: 4
        },
        end: {
          line: 212,
          column: 5
        }
      },
      "69": {
        start: {
          line: 210,
          column: 6
        },
        end: {
          line: 210,
          column: 39
        }
      },
      "70": {
        start: {
          line: 211,
          column: 6
        },
        end: {
          line: 211,
          column: 24
        }
      },
      "71": {
        start: {
          line: 223,
          column: 4
        },
        end: {
          line: 223,
          column: 54
        }
      },
      "72": {
        start: {
          line: 223,
          column: 43
        },
        end: {
          line: 223,
          column: 54
        }
      },
      "73": {
        start: {
          line: 225,
          column: 4
        },
        end: {
          line: 232,
          column: 5
        }
      },
      "74": {
        start: {
          line: 231,
          column: 6
        },
        end: {
          line: 231,
          column: 17
        }
      },
      "75": {
        start: {
          line: 233,
          column: 4
        },
        end: {
          line: 233,
          column: 39
        }
      },
      "76": {
        start: {
          line: 233,
          column: 27
        },
        end: {
          line: 233,
          column: 39
        }
      },
      "77": {
        start: {
          line: 234,
          column: 4
        },
        end: {
          line: 234,
          column: 50
        }
      },
      "78": {
        start: {
          line: 238,
          column: 4
        },
        end: {
          line: 238,
          column: 30
        }
      },
      "79": {
        start: {
          line: 242,
          column: 4
        },
        end: {
          line: 242,
          column: 24
        }
      },
      "80": {
        start: {
          line: 246,
          column: 4
        },
        end: {
          line: 246,
          column: 21
        }
      },
      "81": {
        start: {
          line: 250,
          column: 4
        },
        end: {
          line: 250,
          column: 66
        }
      },
      "82": {
        start: {
          line: 254,
          column: 4
        },
        end: {
          line: 254,
          column: 69
        }
      },
      "83": {
        start: {
          line: 258,
          column: 17
        },
        end: {
          line: 258,
          column: 59
        }
      },
      "84": {
        start: {
          line: 259,
          column: 4
        },
        end: {
          line: 266,
          column: 5
        }
      },
      "85": {
        start: {
          line: 260,
          column: 6
        },
        end: {
          line: 264,
          column: 7
        }
      },
      "86": {
        start: {
          line: 261,
          column: 8
        },
        end: {
          line: 261,
          column: 26
        }
      },
      "87": {
        start: {
          line: 262,
          column: 8
        },
        end: {
          line: 262,
          column: 27
        }
      },
      "88": {
        start: {
          line: 263,
          column: 8
        },
        end: {
          line: 263,
          column: 45
        }
      },
      "89": {
        start: {
          line: 263,
          column: 26
        },
        end: {
          line: 263,
          column: 45
        }
      },
      "90": {
        start: {
          line: 265,
          column: 6
        },
        end: {
          line: 265,
          column: 35
        }
      },
      "91": {
        start: {
          line: 270,
          column: 35
        },
        end: {
          line: 270,
          column: 45
        }
      },
      "92": {
        start: {
          line: 271,
          column: 18
        },
        end: {
          line: 271,
          column: 40
        }
      },
      "93": {
        start: {
          line: 272,
          column: 19
        },
        end: {
          line: 272,
          column: 45
        }
      },
      "94": {
        start: {
          line: 273,
          column: 4
        },
        end: {
          line: 278,
          column: 5
        }
      },
      "95": {
        start: {
          line: 274,
          column: 6
        },
        end: {
          line: 277,
          column: 7
        }
      },
      "96": {
        start: {
          line: 275,
          column: 8
        },
        end: {
          line: 275,
          column: 34
        }
      },
      "97": {
        start: {
          line: 276,
          column: 8
        },
        end: {
          line: 276,
          column: 14
        }
      },
      "98": {
        start: {
          line: 279,
          column: 4
        },
        end: {
          line: 279,
          column: 29
        }
      },
      "99": {
        start: {
          line: 283,
          column: 4
        },
        end: {
          line: 283,
          column: 49
        }
      },
      "100": {
        start: {
          line: 283,
          column: 43
        },
        end: {
          line: 283,
          column: 49
        }
      },
      "101": {
        start: {
          line: 284,
          column: 4
        },
        end: {
          line: 284,
          column: 36
        }
      },
      "102": {
        start: {
          line: 284,
          column: 30
        },
        end: {
          line: 284,
          column: 36
        }
      },
      "103": {
        start: {
          line: 286,
          column: 4
        },
        end: {
          line: 286,
          column: 79
        }
      },
      "104": {
        start: {
          line: 286,
          column: 73
        },
        end: {
          line: 286,
          column: 79
        }
      },
      "105": {
        start: {
          line: 287,
          column: 57
        },
        end: {
          line: 287,
          column: 67
        }
      },
      "106": {
        start: {
          line: 288,
          column: 23
        },
        end: {
          line: 288,
          column: 33
        }
      },
      "107": {
        start: {
          line: 289,
          column: 4
        },
        end: {
          line: 298,
          column: 5
        }
      },
      "108": {
        start: {
          line: 290,
          column: 27
        },
        end: {
          line: 290,
          column: 41
        }
      },
      "109": {
        start: {
          line: 291,
          column: 26
        },
        end: {
          line: 291,
          column: 68
        }
      },
      "110": {
        start: {
          line: 292,
          column: 19
        },
        end: {
          line: 292,
          column: 54
        }
      },
      "111": {
        start: {
          line: 294,
          column: 21
        },
        end: {
          line: 294,
          column: 22
        }
      },
      "112": {
        start: {
          line: 295,
          column: 21
        },
        end: {
          line: 295,
          column: 50
        }
      },
      "113": {
        start: {
          line: 296,
          column: 24
        },
        end: {
          line: 296,
          column: 61
        }
      },
      "114": {
        start: {
          line: 297,
          column: 6
        },
        end: {
          line: 297,
          column: 66
        }
      },
      "115": {
        start: {
          line: 297,
          column: 46
        },
        end: {
          line: 297,
          column: 66
        }
      },
      "116": {
        start: {
          line: 299,
          column: 4
        },
        end: {
          line: 299,
          column: 37
        }
      },
      "117": {
        start: {
          line: 299,
          column: 20
        },
        end: {
          line: 299,
          column: 37
        }
      },
      "118": {
        start: {
          line: 300,
          column: 4
        },
        end: {
          line: 300,
          column: 63
        }
      },
      "119": {
        start: {
          line: 302,
          column: 4
        },
        end: {
          line: 305,
          column: 5
        }
      },
      "120": {
        start: {
          line: 303,
          column: 6
        },
        end: {
          line: 303,
          column: 25
        }
      },
      "121": {
        start: {
          line: 304,
          column: 6
        },
        end: {
          line: 304,
          column: 32
        }
      },
      "122": {
        start: {
          line: 309,
          column: 4
        },
        end: {
          line: 309,
          column: 66
        }
      },
      "123": {
        start: {
          line: 309,
          column: 40
        },
        end: {
          line: 309,
          column: 66
        }
      },
      "124": {
        start: {
          line: 313,
          column: 91
        },
        end: {
          line: 313,
          column: 101
        }
      },
      "125": {
        start: {
          line: 314,
          column: 4
        },
        end: {
          line: 314,
          column: 49
        }
      },
      "126": {
        start: {
          line: 314,
          column: 43
        },
        end: {
          line: 314,
          column: 49
        }
      },
      "127": {
        start: {
          line: 317,
          column: 4
        },
        end: {
          line: 321,
          column: 5
        }
      },
      "128": {
        start: {
          line: 318,
          column: 6
        },
        end: {
          line: 318,
          column: 41
        }
      },
      "129": {
        start: {
          line: 319,
          column: 6
        },
        end: {
          line: 319,
          column: 39
        }
      },
      "130": {
        start: {
          line: 320,
          column: 6
        },
        end: {
          line: 320,
          column: 32
        }
      },
      "131": {
        start: {
          line: 322,
          column: 42
        },
        end: {
          line: 322,
          column: 64
        }
      },
      "132": {
        start: {
          line: 323,
          column: 4
        },
        end: {
          line: 345,
          column: 5
        }
      },
      "133": {
        start: {
          line: 324,
          column: 6
        },
        end: {
          line: 335,
          column: 7
        }
      },
      "134": {
        start: {
          line: 325,
          column: 8
        },
        end: {
          line: 325,
          column: 35
        }
      },
      "135": {
        start: {
          line: 327,
          column: 24
        },
        end: {
          line: 327,
          column: 50
        }
      },
      "136": {
        start: {
          line: 328,
          column: 8
        },
        end: {
          line: 333,
          column: 9
        }
      },
      "137": {
        start: {
          line: 329,
          column: 10
        },
        end: {
          line: 329,
          column: 33
        }
      },
      "138": {
        start: {
          line: 331,
          column: 10
        },
        end: {
          line: 331,
          column: 40
        }
      },
      "139": {
        start: {
          line: 331,
          column: 34
        },
        end: {
          line: 331,
          column: 40
        }
      },
      "140": {
        start: {
          line: 332,
          column: 10
        },
        end: {
          line: 332,
          column: 28
        }
      },
      "141": {
        start: {
          line: 334,
          column: 8
        },
        end: {
          line: 334,
          column: 46
        }
      },
      "142": {
        start: {
          line: 334,
          column: 29
        },
        end: {
          line: 334,
          column: 46
        }
      },
      "143": {
        start: {
          line: 337,
          column: 6
        },
        end: {
          line: 337,
          column: 29
        }
      },
      "144": {
        start: {
          line: 338,
          column: 6
        },
        end: {
          line: 338,
          column: 43
        }
      },
      "145": {
        start: {
          line: 338,
          column: 20
        },
        end: {
          line: 338,
          column: 43
        }
      },
      "146": {
        start: {
          line: 340,
          column: 6
        },
        end: {
          line: 344,
          column: 12
        }
      },
      "147": {
        start: {
          line: 341,
          column: 8
        },
        end: {
          line: 341,
          column: 61
        }
      },
      "148": {
        start: {
          line: 341,
          column: 40
        },
        end: {
          line: 341,
          column: 61
        }
      },
      "149": {
        start: {
          line: 342,
          column: 8
        },
        end: {
          line: 342,
          column: 43
        }
      },
      "150": {
        start: {
          line: 342,
          column: 37
        },
        end: {
          line: 342,
          column: 43
        }
      },
      "151": {
        start: {
          line: 343,
          column: 8
        },
        end: {
          line: 343,
          column: 46
        }
      },
      "152": {
        start: {
          line: 343,
          column: 26
        },
        end: {
          line: 343,
          column: 46
        }
      },
      "153": {
        start: {
          line: 347,
          column: 4
        },
        end: {
          line: 347,
          column: 74
        }
      },
      "154": {
        start: {
          line: 347,
          column: 52
        },
        end: {
          line: 347,
          column: 74
        }
      },
      "155": {
        start: {
          line: 359,
          column: 4
        },
        end: {
          line: 359,
          column: 65
        }
      },
      "156": {
        start: {
          line: 359,
          column: 54
        },
        end: {
          line: 359,
          column: 65
        }
      },
      "157": {
        start: {
          line: 360,
          column: 4
        },
        end: {
          line: 360,
          column: 63
        }
      },
      "158": {
        start: {
          line: 360,
          column: 52
        },
        end: {
          line: 360,
          column: 63
        }
      },
      "159": {
        start: {
          line: 361,
          column: 4
        },
        end: {
          line: 361,
          column: 16
        }
      },
      "160": {
        start: {
          line: 365,
          column: 4
        },
        end: {
          line: 365,
          column: 43
        }
      },
      "161": {
        start: {
          line: 365,
          column: 37
        },
        end: {
          line: 365,
          column: 43
        }
      },
      "162": {
        start: {
          line: 366,
          column: 4
        },
        end: {
          line: 366,
          column: 25
        }
      },
      "163": {
        start: {
          line: 370,
          column: 43
        },
        end: {
          line: 370,
          column: 53
        }
      },
      "164": {
        start: {
          line: 371,
          column: 4
        },
        end: {
          line: 371,
          column: 27
        }
      },
      "165": {
        start: {
          line: 372,
          column: 20
        },
        end: {
          line: 372,
          column: 48
        }
      },
      "166": {
        start: {
          line: 373,
          column: 4
        },
        end: {
          line: 375,
          column: 5
        }
      },
      "167": {
        start: {
          line: 374,
          column: 6
        },
        end: {
          line: 374,
          column: 75
        }
      },
      "168": {
        start: {
          line: 374,
          column: 39
        },
        end: {
          line: 374,
          column: 75
        }
      },
      "169": {
        start: {
          line: 379,
          column: 71
        },
        end: {
          line: 379,
          column: 81
        }
      },
      "170": {
        start: {
          line: 380,
          column: 4
        },
        end: {
          line: 383,
          column: 5
        }
      },
      "171": {
        start: {
          line: 381,
          column: 6
        },
        end: {
          line: 381,
          column: 46
        }
      },
      "172": {
        start: {
          line: 382,
          column: 6
        },
        end: {
          line: 382,
          column: 12
        }
      },
      "173": {
        start: {
          line: 384,
          column: 4
        },
        end: {
          line: 384,
          column: 25
        }
      },
      "174": {
        start: {
          line: 384,
          column: 19
        },
        end: {
          line: 384,
          column: 25
        }
      },
      "175": {
        start: {
          line: 385,
          column: 4
        },
        end: {
          line: 385,
          column: 33
        }
      },
      "176": {
        start: {
          line: 385,
          column: 27
        },
        end: {
          line: 385,
          column: 33
        }
      },
      "177": {
        start: {
          line: 387,
          column: 4
        },
        end: {
          line: 387,
          column: 44
        }
      },
      "178": {
        start: {
          line: 387,
          column: 38
        },
        end: {
          line: 387,
          column: 44
        }
      },
      "179": {
        start: {
          line: 389,
          column: 4
        },
        end: {
          line: 392,
          column: 5
        }
      },
      "180": {
        start: {
          line: 390,
          column: 22
        },
        end: {
          line: 390,
          column: 50
        }
      },
      "181": {
        start: {
          line: 391,
          column: 6
        },
        end: {
          line: 391,
          column: 45
        }
      },
      "182": {
        start: {
          line: 395,
          column: 4
        },
        end: {
          line: 398,
          column: 11
        }
      },
      "183": {
        start: {
          line: 396,
          column: 6
        },
        end: {
          line: 396,
          column: 46
        }
      },
      "184": {
        start: {
          line: 396,
          column: 28
        },
        end: {
          line: 396,
          column: 46
        }
      },
      "185": {
        start: {
          line: 397,
          column: 6
        },
        end: {
          line: 397,
          column: 29
        }
      },
      "186": {
        start: {
          line: 402,
          column: 4
        },
        end: {
          line: 402,
          column: 55
        }
      },
      "187": {
        start: {
          line: 403,
          column: 4
        },
        end: {
          line: 403,
          column: 24
        }
      },
      "188": {
        start: {
          line: 405,
          column: 4
        },
        end: {
          line: 409,
          column: 5
        }
      },
      "189": {
        start: {
          line: 406,
          column: 6
        },
        end: {
          line: 406,
          column: 24
        }
      },
      "190": {
        start: {
          line: 408,
          column: 6
        },
        end: {
          line: 408,
          column: 29
        }
      },
      "191": {
        start: {
          line: 413,
          column: 33
        },
        end: {
          line: 413,
          column: 43
        }
      },
      "192": {
        start: {
          line: 414,
          column: 20
        },
        end: {
          line: 414,
          column: 42
        }
      },
      "193": {
        start: {
          line: 415,
          column: 4
        },
        end: {
          line: 418,
          column: 5
        }
      },
      "194": {
        start: {
          line: 416,
          column: 6
        },
        end: {
          line: 416,
          column: 44
        }
      },
      "195": {
        start: {
          line: 416,
          column: 27
        },
        end: {
          line: 416,
          column: 44
        }
      },
      "196": {
        start: {
          line: 417,
          column: 6
        },
        end: {
          line: 417,
          column: 12
        }
      },
      "197": {
        start: {
          line: 419,
          column: 4
        },
        end: {
          line: 419,
          column: 38
        }
      },
      "198": {
        start: {
          line: 423,
          column: 43
        },
        end: {
          line: 423,
          column: 53
        }
      },
      "199": {
        start: {
          line: 424,
          column: 23
        },
        end: {
          line: 424,
          column: 77
        }
      },
      "200": {
        start: {
          line: 425,
          column: 4
        },
        end: {
          line: 428,
          column: 5
        }
      },
      "201": {
        start: {
          line: 426,
          column: 6
        },
        end: {
          line: 426,
          column: 29
        }
      },
      "202": {
        start: {
          line: 427,
          column: 6
        },
        end: {
          line: 427,
          column: 12
        }
      },
      "203": {
        start: {
          line: 429,
          column: 15
        },
        end: {
          line: 429,
          column: 43
        }
      },
      "204": {
        start: {
          line: 430,
          column: 4
        },
        end: {
          line: 433,
          column: 5
        }
      },
      "205": {
        start: {
          line: 432,
          column: 6
        },
        end: {
          line: 432,
          column: 31
        }
      },
      "206": {
        start: {
          line: 434,
          column: 4
        },
        end: {
          line: 438,
          column: 5
        }
      },
      "207": {
        start: {
          line: 435,
          column: 22
        },
        end: {
          line: 435,
          column: 51
        }
      },
      "208": {
        start: {
          line: 436,
          column: 6
        },
        end: {
          line: 436,
          column: 38
        }
      },
      "209": {
        start: {
          line: 437,
          column: 6
        },
        end: {
          line: 437,
          column: 78
        }
      },
      "210": {
        start: {
          line: 437,
          column: 39
        },
        end: {
          line: 437,
          column: 78
        }
      },
      "211": {
        start: {
          line: 442,
          column: 30
        },
        end: {
          line: 442,
          column: 40
        }
      },
      "212": {
        start: {
          line: 443,
          column: 4
        },
        end: {
          line: 443,
          column: 25
        }
      },
      "213": {
        start: {
          line: 445,
          column: 4
        },
        end: {
          line: 453,
          column: 5
        }
      },
      "214": {
        start: {
          line: 446,
          column: 6
        },
        end: {
          line: 446,
          column: 24
        }
      },
      "215": {
        start: {
          line: 447,
          column: 6
        },
        end: {
          line: 450,
          column: 7
        }
      },
      "216": {
        start: {
          line: 448,
          column: 24
        },
        end: {
          line: 448,
          column: 40
        }
      },
      "217": {
        start: {
          line: 449,
          column: 8
        },
        end: {
          line: 449,
          column: 37
        }
      },
      "218": {
        start: {
          line: 449,
          column: 31
        },
        end: {
          line: 449,
          column: 37
        }
      },
      "219": {
        start: {
          line: 451,
          column: 6
        },
        end: {
          line: 451,
          column: 74
        }
      },
      "220": {
        start: {
          line: 452,
          column: 6
        },
        end: {
          line: 452,
          column: 12
        }
      },
      "221": {
        start: {
          line: 456,
          column: 4
        },
        end: {
          line: 462,
          column: 5
        }
      },
      "222": {
        start: {
          line: 457,
          column: 6
        },
        end: {
          line: 457,
          column: 33
        }
      },
      "223": {
        start: {
          line: 459,
          column: 6
        },
        end: {
          line: 460,
          column: 32
        }
      },
      "224": {
        start: {
          line: 459,
          column: 22
        },
        end: {
          line: 459,
          column: 48
        }
      },
      "225": {
        start: {
          line: 460,
          column: 11
        },
        end: {
          line: 460,
          column: 32
        }
      },
      "226": {
        start: {
          line: 461,
          column: 6
        },
        end: {
          line: 461,
          column: 12
        }
      },
      "227": {
        start: {
          line: 465,
          column: 4
        },
        end: {
          line: 465,
          column: 27
        }
      },
      "228": {
        start: {
          line: 465,
          column: 21
        },
        end: {
          line: 465,
          column: 27
        }
      },
      "229": {
        start: {
          line: 467,
          column: 4
        },
        end: {
          line: 467,
          column: 40
        }
      },
      "230": {
        start: {
          line: 469,
          column: 4
        },
        end: {
          line: 488,
          column: 5
        }
      },
      "231": {
        start: {
          line: 471,
          column: 8
        },
        end: {
          line: 471,
          column: 68
        }
      },
      "232": {
        start: {
          line: 471,
          column: 39
        },
        end: {
          line: 471,
          column: 68
        }
      },
      "233": {
        start: {
          line: 472,
          column: 8
        },
        end: {
          line: 472,
          column: 26
        }
      },
      "234": {
        start: {
          line: 473,
          column: 8
        },
        end: {
          line: 473,
          column: 13
        }
      },
      "235": {
        start: {
          line: 475,
          column: 8
        },
        end: {
          line: 475,
          column: 67
        }
      },
      "236": {
        start: {
          line: 475,
          column: 39
        },
        end: {
          line: 475,
          column: 67
        }
      },
      "237": {
        start: {
          line: 476,
          column: 8
        },
        end: {
          line: 476,
          column: 26
        }
      },
      "238": {
        start: {
          line: 477,
          column: 8
        },
        end: {
          line: 477,
          column: 13
        }
      },
      "239": {
        start: {
          line: 479,
          column: 8
        },
        end: {
          line: 479,
          column: 26
        }
      },
      "240": {
        start: {
          line: 480,
          column: 8
        },
        end: {
          line: 480,
          column: 26
        }
      },
      "241": {
        start: {
          line: 481,
          column: 8
        },
        end: {
          line: 481,
          column: 27
        }
      },
      "242": {
        start: {
          line: 482,
          column: 8
        },
        end: {
          line: 482,
          column: 13
        }
      },
      "243": {
        start: {
          line: 484,
          column: 8
        },
        end: {
          line: 484,
          column: 28
        }
      },
      "244": {
        start: {
          line: 485,
          column: 8
        },
        end: {
          line: 485,
          column: 13
        }
      },
      "245": {
        start: {
          line: 487,
          column: 8
        },
        end: {
          line: 487,
          column: 44
        }
      },
      "246": {
        start: {
          line: 492,
          column: 4
        },
        end: {
          line: 492,
          column: 26
        }
      },
      "247": {
        start: {
          line: 496,
          column: 4
        },
        end: {
          line: 498,
          column: 5
        }
      },
      "248": {
        start: {
          line: 497,
          column: 6
        },
        end: {
          line: 497,
          column: 46
        }
      },
      "249": {
        start: {
          line: 499,
          column: 4
        },
        end: {
          line: 501,
          column: 11
        }
      },
      "250": {
        start: {
          line: 500,
          column: 6
        },
        end: {
          line: 500,
          column: 29
        }
      },
      "251": {
        start: {
          line: 505,
          column: 56
        },
        end: {
          line: 505,
          column: 66
        }
      },
      "252": {
        start: {
          line: 506,
          column: 4
        },
        end: {
          line: 506,
          column: 25
        }
      },
      "253": {
        start: {
          line: 506,
          column: 19
        },
        end: {
          line: 506,
          column: 25
        }
      },
      "254": {
        start: {
          line: 507,
          column: 4
        },
        end: {
          line: 511,
          column: 5
        }
      },
      "255": {
        start: {
          line: 508,
          column: 6
        },
        end: {
          line: 508,
          column: 28
        }
      },
      "256": {
        start: {
          line: 509,
          column: 11
        },
        end: {
          line: 511,
          column: 5
        }
      },
      "257": {
        start: {
          line: 510,
          column: 6
        },
        end: {
          line: 510,
          column: 29
        }
      },
      "258": {
        start: {
          line: 512,
          column: 4
        },
        end: {
          line: 512,
          column: 44
        }
      },
      "259": {
        start: {
          line: 512,
          column: 38
        },
        end: {
          line: 512,
          column: 44
        }
      },
      "260": {
        start: {
          line: 513,
          column: 4
        },
        end: {
          line: 513,
          column: 65
        }
      },
      "261": {
        start: {
          line: 513,
          column: 59
        },
        end: {
          line: 513,
          column: 65
        }
      },
      "262": {
        start: {
          line: 514,
          column: 4
        },
        end: {
          line: 514,
          column: 22
        }
      },
      "263": {
        start: {
          line: 515,
          column: 17
        },
        end: {
          line: 515,
          column: 55
        }
      },
      "264": {
        start: {
          line: 516,
          column: 19
        },
        end: {
          line: 516,
          column: 28
        }
      },
      "265": {
        start: {
          line: 517,
          column: 4
        },
        end: {
          line: 527,
          column: 5
        }
      },
      "266": {
        start: {
          line: 519,
          column: 6
        },
        end: {
          line: 526,
          column: 7
        }
      },
      "267": {
        start: {
          line: 520,
          column: 21
        },
        end: {
          line: 520,
          column: 30
        }
      },
      "268": {
        start: {
          line: 521,
          column: 8
        },
        end: {
          line: 525,
          column: 9
        }
      },
      "269": {
        start: {
          line: 522,
          column: 10
        },
        end: {
          line: 522,
          column: 29
        }
      },
      "270": {
        start: {
          line: 523,
          column: 10
        },
        end: {
          line: 523,
          column: 77
        }
      },
      "271": {
        start: {
          line: 524,
          column: 10
        },
        end: {
          line: 524,
          column: 16
        }
      },
      "272": {
        start: {
          line: 531,
          column: 53
        },
        end: {
          line: 531,
          column: 63
        }
      },
      "273": {
        start: {
          line: 532,
          column: 23
        },
        end: {
          line: 532,
          column: 51
        }
      },
      "274": {
        start: {
          line: 533,
          column: 4
        },
        end: {
          line: 536,
          column: 5
        }
      },
      "275": {
        start: {
          line: 535,
          column: 6
        },
        end: {
          line: 535,
          column: 75
        }
      },
      "276": {
        start: {
          line: 535,
          column: 39
        },
        end: {
          line: 535,
          column: 75
        }
      },
      "277": {
        start: {
          line: 537,
          column: 4
        },
        end: {
          line: 539,
          column: 5
        }
      },
      "278": {
        start: {
          line: 538,
          column: 6
        },
        end: {
          line: 538,
          column: 76
        }
      },
      "279": {
        start: {
          line: 538,
          column: 39
        },
        end: {
          line: 538,
          column: 76
        }
      },
      "280": {
        start: {
          line: 540,
          column: 4
        },
        end: {
          line: 542,
          column: 5
        }
      },
      "281": {
        start: {
          line: 541,
          column: 6
        },
        end: {
          line: 541,
          column: 23
        }
      },
      "282": {
        start: {
          line: 546,
          column: 27
        },
        end: {
          line: 546,
          column: 37
        }
      },
      "283": {
        start: {
          line: 547,
          column: 4
        },
        end: {
          line: 549,
          column: 66
        }
      },
      "284": {
        start: {
          line: 553,
          column: 29
        },
        end: {
          line: 553,
          column: 39
        }
      },
      "285": {
        start: {
          line: 554,
          column: 4
        },
        end: {
          line: 554,
          column: 58
        }
      },
      "286": {
        start: {
          line: 554,
          column: 23
        },
        end: {
          line: 554,
          column: 58
        }
      },
      "287": {
        start: {
          line: 555,
          column: 4
        },
        end: {
          line: 555,
          column: 94
        }
      },
      "288": {
        start: {
          line: 562,
          column: 23
        },
        end: {
          line: 562,
          column: 33
        }
      },
      "289": {
        start: {
          line: 563,
          column: 4
        },
        end: {
          line: 563,
          column: 105
        }
      },
      "290": {
        start: {
          line: 563,
          column: 38
        },
        end: {
          line: 563,
          column: 105
        }
      },
      "291": {
        start: {
          line: 564,
          column: 4
        },
        end: {
          line: 564,
          column: 15
        }
      },
      "292": {
        start: {
          line: 568,
          column: 25
        },
        end: {
          line: 568,
          column: 35
        }
      },
      "293": {
        start: {
          line: 569,
          column: 28
        },
        end: {
          line: 569,
          column: 38
        }
      },
      "294": {
        start: {
          line: 570,
          column: 18
        },
        end: {
          line: 592,
          column: 5
        }
      },
      "295": {
        start: {
          line: 593,
          column: 39
        },
        end: {
          line: 593,
          column: 115
        }
      },
      "296": {
        start: {
          line: 594,
          column: 4
        },
        end: {
          line: 608,
          column: 5
        }
      },
      "297": {
        start: {
          line: 612,
          column: 34
        },
        end: {
          line: 612,
          column: 44
        }
      },
      "298": {
        start: {
          line: 613,
          column: 46
        },
        end: {
          line: 613,
          column: 56
        }
      },
      "299": {
        start: {
          line: 614,
          column: 18
        },
        end: {
          line: 635,
          column: 5
        }
      },
      "300": {
        start: {
          line: 636,
          column: 39
        },
        end: {
          line: 636,
          column: 80
        }
      },
      "301": {
        start: {
          line: 637,
          column: 4
        },
        end: {
          line: 658,
          column: 5
        }
      },
      "302": {
        start: {
          line: 638,
          column: 6
        },
        end: {
          line: 657,
          column: 7
        }
      },
      "303": {
        start: {
          line: 659,
          column: 4
        },
        end: {
          line: 680,
          column: 5
        }
      },
      "304": {
        start: {
          line: 684,
          column: 25
        },
        end: {
          line: 684,
          column: 35
        }
      },
      "305": {
        start: {
          line: 685,
          column: 4
        },
        end: {
          line: 685,
          column: 42
        }
      },
      "306": {
        start: {
          line: 685,
          column: 18
        },
        end: {
          line: 685,
          column: 42
        }
      },
      "307": {
        start: {
          line: 686,
          column: 4
        },
        end: {
          line: 686,
          column: 28
        }
      },
      "308": {
        start: {
          line: 712,
          column: 8
        },
        end: {
          line: 712,
          column: 18
        }
      },
      "309": {
        start: {
          line: 713,
          column: 21
        },
        end: {
          line: 713,
          column: 45
        }
      },
      "310": {
        start: {
          line: 714,
          column: 22
        },
        end: {
          line: 722,
          column: 5
        }
      },
      "311": {
        start: {
          line: 723,
          column: 4
        },
        end: {
          line: 770,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 23,
            column: 17
          },
          end: {
            line: 23,
            column: 18
          }
        },
        loc: {
          start: {
            line: 23,
            column: 60
          },
          end: {
            line: 23,
            column: 114
          }
        },
        line: 23
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 33,
            column: 14
          },
          end: {
            line: 33,
            column: 15
          }
        },
        loc: {
          start: {
            line: 33,
            column: 26
          },
          end: {
            line: 33,
            column: 27
          }
        },
        line: 33
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 91,
            column: 3
          }
        },
        loc: {
          start: {
            line: 91,
            column: 51
          },
          end: {
            line: 137,
            column: 3
          }
        },
        line: 91
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 139,
            column: 2
          },
          end: {
            line: 139,
            column: 3
          }
        },
        loc: {
          start: {
            line: 139,
            column: 22
          },
          end: {
            line: 146,
            column: 3
          }
        },
        line: 139
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 148,
            column: 2
          },
          end: {
            line: 148,
            column: 3
          }
        },
        loc: {
          start: {
            line: 148,
            column: 86
          },
          end: {
            line: 162,
            column: 3
          }
        },
        line: 148
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 157,
            column: 19
          },
          end: {
            line: 157,
            column: 20
          }
        },
        loc: {
          start: {
            line: 157,
            column: 25
          },
          end: {
            line: 159,
            column: 9
          }
        },
        line: 157
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 164,
            column: 2
          },
          end: {
            line: 164,
            column: 3
          }
        },
        loc: {
          start: {
            line: 164,
            column: 25
          },
          end: {
            line: 171,
            column: 3
          }
        },
        line: 164
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 173,
            column: 2
          },
          end: {
            line: 173,
            column: 3
          }
        },
        loc: {
          start: {
            line: 173,
            column: 14
          },
          end: {
            line: 178,
            column: 3
          }
        },
        line: 173
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 180,
            column: 2
          },
          end: {
            line: 180,
            column: 3
          }
        },
        loc: {
          start: {
            line: 180,
            column: 17
          },
          end: {
            line: 189,
            column: 3
          }
        },
        line: 180
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 191,
            column: 2
          },
          end: {
            line: 191,
            column: 3
          }
        },
        loc: {
          start: {
            line: 191,
            column: 22
          },
          end: {
            line: 196,
            column: 3
          }
        },
        line: 191
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 198,
            column: 2
          },
          end: {
            line: 198,
            column: 3
          }
        },
        loc: {
          start: {
            line: 198,
            column: 21
          },
          end: {
            line: 202,
            column: 3
          }
        },
        line: 198
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 204,
            column: 2
          },
          end: {
            line: 204,
            column: 3
          }
        },
        loc: {
          start: {
            line: 204,
            column: 32
          },
          end: {
            line: 206,
            column: 3
          }
        },
        line: 204
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 208,
            column: 16
          },
          end: {
            line: 208,
            column: 17
          }
        },
        loc: {
          start: {
            line: 208,
            column: 22
          },
          end: {
            line: 213,
            column: 3
          }
        },
        line: 208
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 216,
            column: 2
          },
          end: {
            line: 216,
            column: 3
          }
        },
        loc: {
          start: {
            line: 216,
            column: 23
          },
          end: {
            line: 235,
            column: 3
          }
        },
        line: 216
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 237,
            column: 2
          },
          end: {
            line: 237,
            column: 3
          }
        },
        loc: {
          start: {
            line: 237,
            column: 74
          },
          end: {
            line: 239,
            column: 3
          }
        },
        line: 237
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 241,
            column: 2
          },
          end: {
            line: 241,
            column: 3
          }
        },
        loc: {
          start: {
            line: 241,
            column: 50
          },
          end: {
            line: 243,
            column: 3
          }
        },
        line: 241
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 245,
            column: 2
          },
          end: {
            line: 245,
            column: 3
          }
        },
        loc: {
          start: {
            line: 245,
            column: 34
          },
          end: {
            line: 247,
            column: 3
          }
        },
        line: 245
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 249,
            column: 2
          },
          end: {
            line: 249,
            column: 3
          }
        },
        loc: {
          start: {
            line: 249,
            column: 18
          },
          end: {
            line: 251,
            column: 3
          }
        },
        line: 249
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 253,
            column: 2
          },
          end: {
            line: 253,
            column: 3
          }
        },
        loc: {
          start: {
            line: 253,
            column: 19
          },
          end: {
            line: 255,
            column: 3
          }
        },
        line: 253
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 257,
            column: 2
          },
          end: {
            line: 257,
            column: 3
          }
        },
        loc: {
          start: {
            line: 257,
            column: 26
          },
          end: {
            line: 267,
            column: 3
          }
        },
        line: 257
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 269,
            column: 2
          },
          end: {
            line: 269,
            column: 3
          }
        },
        loc: {
          start: {
            line: 269,
            column: 51
          },
          end: {
            line: 280,
            column: 3
          }
        },
        line: 269
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 282,
            column: 2
          },
          end: {
            line: 282,
            column: 3
          }
        },
        loc: {
          start: {
            line: 282,
            column: 39
          },
          end: {
            line: 306,
            column: 3
          }
        },
        line: 282
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 308,
            column: 2
          },
          end: {
            line: 308,
            column: 3
          }
        },
        loc: {
          start: {
            line: 308,
            column: 53
          },
          end: {
            line: 310,
            column: 3
          }
        },
        line: 308
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 312,
            column: 2
          },
          end: {
            line: 312,
            column: 3
          }
        },
        loc: {
          start: {
            line: 312,
            column: 80
          },
          end: {
            line: 348,
            column: 3
          }
        },
        line: 312
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 340,
            column: 17
          },
          end: {
            line: 340,
            column: 18
          }
        },
        loc: {
          start: {
            line: 340,
            column: 23
          },
          end: {
            line: 344,
            column: 7
          }
        },
        line: 340
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 358,
            column: 2
          },
          end: {
            line: 358,
            column: 3
          }
        },
        loc: {
          start: {
            line: 358,
            column: 34
          },
          end: {
            line: 362,
            column: 3
          }
        },
        line: 358
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 364,
            column: 2
          },
          end: {
            line: 364,
            column: 3
          }
        },
        loc: {
          start: {
            line: 364,
            column: 51
          },
          end: {
            line: 367,
            column: 3
          }
        },
        line: 364
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 369,
            column: 2
          },
          end: {
            line: 369,
            column: 3
          }
        },
        loc: {
          start: {
            line: 369,
            column: 21
          },
          end: {
            line: 376,
            column: 3
          }
        },
        line: 369
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 378,
            column: 2
          },
          end: {
            line: 378,
            column: 3
          }
        },
        loc: {
          start: {
            line: 378,
            column: 32
          },
          end: {
            line: 399,
            column: 3
          }
        },
        line: 378
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 389,
            column: 23
          },
          end: {
            line: 389,
            column: 24
          }
        },
        loc: {
          start: {
            line: 389,
            column: 29
          },
          end: {
            line: 392,
            column: 5
          }
        },
        line: 389
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 395,
            column: 37
          },
          end: {
            line: 395,
            column: 38
          }
        },
        loc: {
          start: {
            line: 395,
            column: 43
          },
          end: {
            line: 398,
            column: 5
          }
        },
        line: 395
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 401,
            column: 2
          },
          end: {
            line: 401,
            column: 3
          }
        },
        loc: {
          start: {
            line: 401,
            column: 16
          },
          end: {
            line: 410,
            column: 3
          }
        },
        line: 401
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 412,
            column: 2
          },
          end: {
            line: 412,
            column: 3
          }
        },
        loc: {
          start: {
            line: 412,
            column: 21
          },
          end: {
            line: 420,
            column: 3
          }
        },
        line: 412
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 422,
            column: 2
          },
          end: {
            line: 422,
            column: 3
          }
        },
        loc: {
          start: {
            line: 422,
            column: 16
          },
          end: {
            line: 439,
            column: 3
          }
        },
        line: 422
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 441,
            column: 2
          },
          end: {
            line: 441,
            column: 3
          }
        },
        loc: {
          start: {
            line: 441,
            column: 56
          },
          end: {
            line: 489,
            column: 3
          }
        },
        line: 441
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 491,
            column: 2
          },
          end: {
            line: 491,
            column: 3
          }
        },
        loc: {
          start: {
            line: 491,
            column: 16
          },
          end: {
            line: 493,
            column: 3
          }
        },
        line: 491
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 495,
            column: 2
          },
          end: {
            line: 495,
            column: 3
          }
        },
        loc: {
          start: {
            line: 495,
            column: 21
          },
          end: {
            line: 502,
            column: 3
          }
        },
        line: 495
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 499,
            column: 44
          },
          end: {
            line: 499,
            column: 45
          }
        },
        loc: {
          start: {
            line: 499,
            column: 50
          },
          end: {
            line: 501,
            column: 5
          }
        },
        line: 499
      },
      "38": {
        name: "(anonymous_38)",
        decl: {
          start: {
            line: 504,
            column: 2
          },
          end: {
            line: 504,
            column: 3
          }
        },
        loc: {
          start: {
            line: 504,
            column: 55
          },
          end: {
            line: 528,
            column: 3
          }
        },
        line: 504
      },
      "39": {
        name: "(anonymous_39)",
        decl: {
          start: {
            line: 530,
            column: 2
          },
          end: {
            line: 530,
            column: 3
          }
        },
        loc: {
          start: {
            line: 530,
            column: 34
          },
          end: {
            line: 543,
            column: 3
          }
        },
        line: 530
      },
      "40": {
        name: "(anonymous_40)",
        decl: {
          start: {
            line: 545,
            column: 2
          },
          end: {
            line: 545,
            column: 3
          }
        },
        loc: {
          start: {
            line: 545,
            column: 40
          },
          end: {
            line: 550,
            column: 3
          }
        },
        line: 545
      },
      "41": {
        name: "(anonymous_41)",
        decl: {
          start: {
            line: 552,
            column: 2
          },
          end: {
            line: 552,
            column: 3
          }
        },
        loc: {
          start: {
            line: 552,
            column: 42
          },
          end: {
            line: 556,
            column: 3
          }
        },
        line: 552
      },
      "42": {
        name: "(anonymous_42)",
        decl: {
          start: {
            line: 561,
            column: 2
          },
          end: {
            line: 561,
            column: 3
          }
        },
        loc: {
          start: {
            line: 561,
            column: 23
          },
          end: {
            line: 565,
            column: 3
          }
        },
        line: 561
      },
      "43": {
        name: "(anonymous_43)",
        decl: {
          start: {
            line: 567,
            column: 2
          },
          end: {
            line: 567,
            column: 3
          }
        },
        loc: {
          start: {
            line: 567,
            column: 15
          },
          end: {
            line: 609,
            column: 3
          }
        },
        line: 567
      },
      "44": {
        name: "(anonymous_44)",
        decl: {
          start: {
            line: 611,
            column: 2
          },
          end: {
            line: 611,
            column: 3
          }
        },
        loc: {
          start: {
            line: 611,
            column: 15
          },
          end: {
            line: 681,
            column: 3
          }
        },
        line: 611
      },
      "45": {
        name: "(anonymous_45)",
        decl: {
          start: {
            line: 683,
            column: 2
          },
          end: {
            line: 683,
            column: 3
          }
        },
        loc: {
          start: {
            line: 683,
            column: 18
          },
          end: {
            line: 687,
            column: 3
          }
        },
        line: 683
      },
      "46": {
        name: "(anonymous_46)",
        decl: {
          start: {
            line: 689,
            column: 2
          },
          end: {
            line: 689,
            column: 3
          }
        },
        loc: {
          start: {
            line: 689,
            column: 11
          },
          end: {
            line: 771,
            column: 3
          }
        },
        line: 689
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 23,
            column: 74
          },
          end: {
            line: 23,
            column: 113
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 23,
            column: 74
          },
          end: {
            line: 23,
            column: 82
          }
        }, {
          start: {
            line: 23,
            column: 86
          },
          end: {
            line: 23,
            column: 113
          }
        }],
        line: 23
      },
      "1": {
        loc: {
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        }, {
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        }],
        line: 143
      },
      "2": {
        loc: {
          start: {
            line: 152,
            column: 4
          },
          end: {
            line: 161,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 152,
            column: 4
          },
          end: {
            line: 161,
            column: 5
          }
        }, {
          start: {
            line: 152,
            column: 4
          },
          end: {
            line: 161,
            column: 5
          }
        }],
        line: 152
      },
      "3": {
        loc: {
          start: {
            line: 153,
            column: 6
          },
          end: {
            line: 160,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 153,
            column: 6
          },
          end: {
            line: 160,
            column: 7
          }
        }, {
          start: {
            line: 153,
            column: 6
          },
          end: {
            line: 160,
            column: 7
          }
        }],
        line: 153
      },
      "4": {
        loc: {
          start: {
            line: 154,
            column: 8
          },
          end: {
            line: 155,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 154,
            column: 9
          },
          end: {
            line: 154,
            column: 45
          }
        }, {
          start: {
            line: 154,
            column: 49
          },
          end: {
            line: 154,
            column: 66
          }
        }, {
          start: {
            line: 155,
            column: 9
          },
          end: {
            line: 155,
            column: 43
          }
        }, {
          start: {
            line: 155,
            column: 47
          },
          end: {
            line: 155,
            column: 63
          }
        }],
        line: 154
      },
      "5": {
        loc: {
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 169,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 169,
            column: 5
          }
        }, {
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 169,
            column: 5
          }
        }],
        line: 167
      },
      "6": {
        loc: {
          start: {
            line: 174,
            column: 4
          },
          end: {
            line: 176,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 174,
            column: 4
          },
          end: {
            line: 176,
            column: 5
          }
        }, {
          start: {
            line: 174,
            column: 4
          },
          end: {
            line: 176,
            column: 5
          }
        }],
        line: 174
      },
      "7": {
        loc: {
          start: {
            line: 181,
            column: 18
          },
          end: {
            line: 181,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 181,
            column: 18
          },
          end: {
            line: 181,
            column: 28
          }
        }, {
          start: {
            line: 181,
            column: 32
          },
          end: {
            line: 181,
            column: 53
          }
        }],
        line: 181
      },
      "8": {
        loc: {
          start: {
            line: 182,
            column: 4
          },
          end: {
            line: 187,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 182,
            column: 4
          },
          end: {
            line: 187,
            column: 7
          }
        }, {
          start: {
            line: 182,
            column: 4
          },
          end: {
            line: 187,
            column: 7
          }
        }],
        line: 182
      },
      "9": {
        loc: {
          start: {
            line: 183,
            column: 6
          },
          end: {
            line: 187,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 183,
            column: 6
          },
          end: {
            line: 187,
            column: 7
          }
        }, {
          start: {
            line: 183,
            column: 6
          },
          end: {
            line: 187,
            column: 7
          }
        }],
        line: 183
      },
      "10": {
        loc: {
          start: {
            line: 185,
            column: 13
          },
          end: {
            line: 187,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 185,
            column: 13
          },
          end: {
            line: 187,
            column: 7
          }
        }, {
          start: {
            line: 185,
            column: 13
          },
          end: {
            line: 187,
            column: 7
          }
        }],
        line: 185
      },
      "11": {
        loc: {
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 194,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 194,
            column: 5
          }
        }, {
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 194,
            column: 5
          }
        }],
        line: 192
      },
      "12": {
        loc: {
          start: {
            line: 200,
            column: 4
          },
          end: {
            line: 200,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 200,
            column: 4
          },
          end: {
            line: 200,
            column: 29
          }
        }, {
          start: {
            line: 200,
            column: 4
          },
          end: {
            line: 200,
            column: 29
          }
        }],
        line: 200
      },
      "13": {
        loc: {
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 212,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 212,
            column: 5
          }
        }, {
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 212,
            column: 5
          }
        }],
        line: 209
      },
      "14": {
        loc: {
          start: {
            line: 209,
            column: 8
          },
          end: {
            line: 209,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 209,
            column: 8
          },
          end: {
            line: 209,
            column: 27
          }
        }, {
          start: {
            line: 209,
            column: 31
          },
          end: {
            line: 209,
            column: 47
          }
        }],
        line: 209
      },
      "15": {
        loc: {
          start: {
            line: 223,
            column: 4
          },
          end: {
            line: 223,
            column: 54
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 223,
            column: 4
          },
          end: {
            line: 223,
            column: 54
          }
        }, {
          start: {
            line: 223,
            column: 4
          },
          end: {
            line: 223,
            column: 54
          }
        }],
        line: 223
      },
      "16": {
        loc: {
          start: {
            line: 225,
            column: 4
          },
          end: {
            line: 232,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 225,
            column: 4
          },
          end: {
            line: 232,
            column: 5
          }
        }, {
          start: {
            line: 225,
            column: 4
          },
          end: {
            line: 232,
            column: 5
          }
        }],
        line: 225
      },
      "17": {
        loc: {
          start: {
            line: 226,
            column: 6
          },
          end: {
            line: 229,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 226,
            column: 6
          },
          end: {
            line: 226,
            column: 28
          }
        }, {
          start: {
            line: 227,
            column: 6
          },
          end: {
            line: 227,
            column: 16
          }
        }, {
          start: {
            line: 228,
            column: 6
          },
          end: {
            line: 228,
            column: 31
          }
        }, {
          start: {
            line: 229,
            column: 6
          },
          end: {
            line: 229,
            column: 54
          }
        }],
        line: 226
      },
      "18": {
        loc: {
          start: {
            line: 233,
            column: 4
          },
          end: {
            line: 233,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 233,
            column: 4
          },
          end: {
            line: 233,
            column: 39
          }
        }, {
          start: {
            line: 233,
            column: 4
          },
          end: {
            line: 233,
            column: 39
          }
        }],
        line: 233
      },
      "19": {
        loc: {
          start: {
            line: 259,
            column: 4
          },
          end: {
            line: 266,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 259,
            column: 4
          },
          end: {
            line: 266,
            column: 5
          }
        }, {
          start: {
            line: 259,
            column: 4
          },
          end: {
            line: 266,
            column: 5
          }
        }],
        line: 259
      },
      "20": {
        loc: {
          start: {
            line: 260,
            column: 6
          },
          end: {
            line: 264,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 260,
            column: 6
          },
          end: {
            line: 264,
            column: 7
          }
        }, {
          start: {
            line: 260,
            column: 6
          },
          end: {
            line: 264,
            column: 7
          }
        }],
        line: 260
      },
      "21": {
        loc: {
          start: {
            line: 263,
            column: 8
          },
          end: {
            line: 263,
            column: 45
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 263,
            column: 8
          },
          end: {
            line: 263,
            column: 45
          }
        }, {
          start: {
            line: 263,
            column: 8
          },
          end: {
            line: 263,
            column: 45
          }
        }],
        line: 263
      },
      "22": {
        loc: {
          start: {
            line: 271,
            column: 18
          },
          end: {
            line: 271,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 271,
            column: 18
          },
          end: {
            line: 271,
            column: 27
          }
        }, {
          start: {
            line: 271,
            column: 31
          },
          end: {
            line: 271,
            column: 40
          }
        }],
        line: 271
      },
      "23": {
        loc: {
          start: {
            line: 273,
            column: 4
          },
          end: {
            line: 278,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 273,
            column: 4
          },
          end: {
            line: 278,
            column: 5
          }
        }, {
          start: {
            line: 273,
            column: 4
          },
          end: {
            line: 278,
            column: 5
          }
        }],
        line: 273
      },
      "24": {
        loc: {
          start: {
            line: 274,
            column: 6
          },
          end: {
            line: 277,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 274,
            column: 6
          },
          end: {
            line: 277,
            column: 7
          }
        }, {
          start: {
            line: 274,
            column: 6
          },
          end: {
            line: 277,
            column: 7
          }
        }],
        line: 274
      },
      "25": {
        loc: {
          start: {
            line: 274,
            column: 10
          },
          end: {
            line: 274,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 274,
            column: 11
          },
          end: {
            line: 274,
            column: 16
          }
        }, {
          start: {
            line: 274,
            column: 20
          },
          end: {
            line: 274,
            column: 36
          }
        }, {
          start: {
            line: 274,
            column: 41
          },
          end: {
            line: 274,
            column: 85
          }
        }],
        line: 274
      },
      "26": {
        loc: {
          start: {
            line: 283,
            column: 4
          },
          end: {
            line: 283,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 283,
            column: 4
          },
          end: {
            line: 283,
            column: 49
          }
        }, {
          start: {
            line: 283,
            column: 4
          },
          end: {
            line: 283,
            column: 49
          }
        }],
        line: 283
      },
      "27": {
        loc: {
          start: {
            line: 284,
            column: 4
          },
          end: {
            line: 284,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 284,
            column: 4
          },
          end: {
            line: 284,
            column: 36
          }
        }, {
          start: {
            line: 284,
            column: 4
          },
          end: {
            line: 284,
            column: 36
          }
        }],
        line: 284
      },
      "28": {
        loc: {
          start: {
            line: 286,
            column: 4
          },
          end: {
            line: 286,
            column: 79
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 286,
            column: 4
          },
          end: {
            line: 286,
            column: 79
          }
        }, {
          start: {
            line: 286,
            column: 4
          },
          end: {
            line: 286,
            column: 79
          }
        }],
        line: 286
      },
      "29": {
        loc: {
          start: {
            line: 286,
            column: 8
          },
          end: {
            line: 286,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 286,
            column: 8
          },
          end: {
            line: 286,
            column: 13
          }
        }, {
          start: {
            line: 286,
            column: 17
          },
          end: {
            line: 286,
            column: 18
          }
        }, {
          start: {
            line: 286,
            column: 22
          },
          end: {
            line: 286,
            column: 71
          }
        }],
        line: 286
      },
      "30": {
        loc: {
          start: {
            line: 287,
            column: 12
          },
          end: {
            line: 287,
            column: 40
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 287,
            column: 21
          },
          end: {
            line: 287,
            column: 40
          }
        }],
        line: 287
      },
      "31": {
        loc: {
          start: {
            line: 289,
            column: 4
          },
          end: {
            line: 298,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 289,
            column: 4
          },
          end: {
            line: 298,
            column: 5
          }
        }, {
          start: {
            line: 289,
            column: 4
          },
          end: {
            line: 298,
            column: 5
          }
        }],
        line: 289
      },
      "32": {
        loc: {
          start: {
            line: 291,
            column: 26
          },
          end: {
            line: 291,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 291,
            column: 26
          },
          end: {
            line: 291,
            column: 52
          }
        }, {
          start: {
            line: 291,
            column: 56
          },
          end: {
            line: 291,
            column: 68
          }
        }],
        line: 291
      },
      "33": {
        loc: {
          start: {
            line: 297,
            column: 6
          },
          end: {
            line: 297,
            column: 66
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 297,
            column: 6
          },
          end: {
            line: 297,
            column: 66
          }
        }, {
          start: {
            line: 297,
            column: 6
          },
          end: {
            line: 297,
            column: 66
          }
        }],
        line: 297
      },
      "34": {
        loc: {
          start: {
            line: 297,
            column: 10
          },
          end: {
            line: 297,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 297,
            column: 10
          },
          end: {
            line: 297,
            column: 31
          }
        }, {
          start: {
            line: 297,
            column: 35
          },
          end: {
            line: 297,
            column: 44
          }
        }],
        line: 297
      },
      "35": {
        loc: {
          start: {
            line: 299,
            column: 4
          },
          end: {
            line: 299,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 299,
            column: 4
          },
          end: {
            line: 299,
            column: 37
          }
        }, {
          start: {
            line: 299,
            column: 4
          },
          end: {
            line: 299,
            column: 37
          }
        }],
        line: 299
      },
      "36": {
        loc: {
          start: {
            line: 300,
            column: 37
          },
          end: {
            line: 300,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 300,
            column: 37
          },
          end: {
            line: 300,
            column: 45
          }
        }, {
          start: {
            line: 300,
            column: 49
          },
          end: {
            line: 300,
            column: 60
          }
        }],
        line: 300
      },
      "37": {
        loc: {
          start: {
            line: 302,
            column: 4
          },
          end: {
            line: 305,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 302,
            column: 4
          },
          end: {
            line: 305,
            column: 5
          }
        }, {
          start: {
            line: 302,
            column: 4
          },
          end: {
            line: 305,
            column: 5
          }
        }],
        line: 302
      },
      "38": {
        loc: {
          start: {
            line: 309,
            column: 4
          },
          end: {
            line: 309,
            column: 66
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 309,
            column: 4
          },
          end: {
            line: 309,
            column: 66
          }
        }, {
          start: {
            line: 309,
            column: 4
          },
          end: {
            line: 309,
            column: 66
          }
        }],
        line: 309
      },
      "39": {
        loc: {
          start: {
            line: 314,
            column: 4
          },
          end: {
            line: 314,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 314,
            column: 4
          },
          end: {
            line: 314,
            column: 49
          }
        }, {
          start: {
            line: 314,
            column: 4
          },
          end: {
            line: 314,
            column: 49
          }
        }],
        line: 314
      },
      "40": {
        loc: {
          start: {
            line: 317,
            column: 4
          },
          end: {
            line: 321,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 317,
            column: 4
          },
          end: {
            line: 321,
            column: 5
          }
        }, {
          start: {
            line: 317,
            column: 4
          },
          end: {
            line: 321,
            column: 5
          }
        }],
        line: 317
      },
      "41": {
        loc: {
          start: {
            line: 323,
            column: 4
          },
          end: {
            line: 345,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 323,
            column: 4
          },
          end: {
            line: 345,
            column: 5
          }
        }, {
          start: {
            line: 323,
            column: 4
          },
          end: {
            line: 345,
            column: 5
          }
        }],
        line: 323
      },
      "42": {
        loc: {
          start: {
            line: 324,
            column: 6
          },
          end: {
            line: 335,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 324,
            column: 6
          },
          end: {
            line: 335,
            column: 7
          }
        }, {
          start: {
            line: 324,
            column: 6
          },
          end: {
            line: 335,
            column: 7
          }
        }],
        line: 324
      },
      "43": {
        loc: {
          start: {
            line: 324,
            column: 10
          },
          end: {
            line: 324,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 324,
            column: 10
          },
          end: {
            line: 324,
            column: 33
          }
        }, {
          start: {
            line: 324,
            column: 37
          },
          end: {
            line: 324,
            column: 71
          }
        }],
        line: 324
      },
      "44": {
        loc: {
          start: {
            line: 328,
            column: 8
          },
          end: {
            line: 333,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 328,
            column: 8
          },
          end: {
            line: 333,
            column: 9
          }
        }, {
          start: {
            line: 328,
            column: 8
          },
          end: {
            line: 333,
            column: 9
          }
        }],
        line: 328
      },
      "45": {
        loc: {
          start: {
            line: 331,
            column: 10
          },
          end: {
            line: 331,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 331,
            column: 10
          },
          end: {
            line: 331,
            column: 40
          }
        }, {
          start: {
            line: 331,
            column: 10
          },
          end: {
            line: 331,
            column: 40
          }
        }],
        line: 331
      },
      "46": {
        loc: {
          start: {
            line: 334,
            column: 8
          },
          end: {
            line: 334,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 334,
            column: 8
          },
          end: {
            line: 334,
            column: 46
          }
        }, {
          start: {
            line: 334,
            column: 8
          },
          end: {
            line: 334,
            column: 46
          }
        }],
        line: 334
      },
      "47": {
        loc: {
          start: {
            line: 338,
            column: 6
          },
          end: {
            line: 338,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 338,
            column: 6
          },
          end: {
            line: 338,
            column: 43
          }
        }, {
          start: {
            line: 338,
            column: 6
          },
          end: {
            line: 338,
            column: 43
          }
        }],
        line: 338
      },
      "48": {
        loc: {
          start: {
            line: 341,
            column: 8
          },
          end: {
            line: 341,
            column: 61
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 341,
            column: 8
          },
          end: {
            line: 341,
            column: 61
          }
        }, {
          start: {
            line: 341,
            column: 8
          },
          end: {
            line: 341,
            column: 61
          }
        }],
        line: 341
      },
      "49": {
        loc: {
          start: {
            line: 341,
            column: 12
          },
          end: {
            line: 341,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 341,
            column: 12
          },
          end: {
            line: 341,
            column: 19
          }
        }, {
          start: {
            line: 341,
            column: 23
          },
          end: {
            line: 341,
            column: 38
          }
        }],
        line: 341
      },
      "50": {
        loc: {
          start: {
            line: 342,
            column: 8
          },
          end: {
            line: 342,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 342,
            column: 8
          },
          end: {
            line: 342,
            column: 43
          }
        }, {
          start: {
            line: 342,
            column: 8
          },
          end: {
            line: 342,
            column: 43
          }
        }],
        line: 342
      },
      "51": {
        loc: {
          start: {
            line: 342,
            column: 12
          },
          end: {
            line: 342,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 342,
            column: 12
          },
          end: {
            line: 342,
            column: 20
          }
        }, {
          start: {
            line: 342,
            column: 24
          },
          end: {
            line: 342,
            column: 35
          }
        }],
        line: 342
      },
      "52": {
        loc: {
          start: {
            line: 343,
            column: 8
          },
          end: {
            line: 343,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 343,
            column: 8
          },
          end: {
            line: 343,
            column: 46
          }
        }, {
          start: {
            line: 343,
            column: 8
          },
          end: {
            line: 343,
            column: 46
          }
        }],
        line: 343
      },
      "53": {
        loc: {
          start: {
            line: 347,
            column: 4
          },
          end: {
            line: 347,
            column: 74
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 347,
            column: 4
          },
          end: {
            line: 347,
            column: 74
          }
        }, {
          start: {
            line: 347,
            column: 4
          },
          end: {
            line: 347,
            column: 74
          }
        }],
        line: 347
      },
      "54": {
        loc: {
          start: {
            line: 347,
            column: 8
          },
          end: {
            line: 347,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 347,
            column: 8
          },
          end: {
            line: 347,
            column: 24
          }
        }, {
          start: {
            line: 347,
            column: 28
          },
          end: {
            line: 347,
            column: 36
          }
        }, {
          start: {
            line: 347,
            column: 40
          },
          end: {
            line: 347,
            column: 50
          }
        }],
        line: 347
      },
      "55": {
        loc: {
          start: {
            line: 359,
            column: 4
          },
          end: {
            line: 359,
            column: 65
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 359,
            column: 4
          },
          end: {
            line: 359,
            column: 65
          }
        }, {
          start: {
            line: 359,
            column: 4
          },
          end: {
            line: 359,
            column: 65
          }
        }],
        line: 359
      },
      "56": {
        loc: {
          start: {
            line: 360,
            column: 4
          },
          end: {
            line: 360,
            column: 63
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 360,
            column: 4
          },
          end: {
            line: 360,
            column: 63
          }
        }, {
          start: {
            line: 360,
            column: 4
          },
          end: {
            line: 360,
            column: 63
          }
        }],
        line: 360
      },
      "57": {
        loc: {
          start: {
            line: 365,
            column: 4
          },
          end: {
            line: 365,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 365,
            column: 4
          },
          end: {
            line: 365,
            column: 43
          }
        }, {
          start: {
            line: 365,
            column: 4
          },
          end: {
            line: 365,
            column: 43
          }
        }],
        line: 365
      },
      "58": {
        loc: {
          start: {
            line: 372,
            column: 20
          },
          end: {
            line: 372,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 372,
            column: 20
          },
          end: {
            line: 372,
            column: 28
          }
        }, {
          start: {
            line: 372,
            column: 32
          },
          end: {
            line: 372,
            column: 48
          }
        }],
        line: 372
      },
      "59": {
        loc: {
          start: {
            line: 373,
            column: 4
          },
          end: {
            line: 375,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 373,
            column: 4
          },
          end: {
            line: 375,
            column: 5
          }
        }, {
          start: {
            line: 373,
            column: 4
          },
          end: {
            line: 375,
            column: 5
          }
        }],
        line: 373
      },
      "60": {
        loc: {
          start: {
            line: 373,
            column: 8
          },
          end: {
            line: 373,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 373,
            column: 8
          },
          end: {
            line: 373,
            column: 28
          }
        }, {
          start: {
            line: 373,
            column: 32
          },
          end: {
            line: 373,
            column: 65
          }
        }, {
          start: {
            line: 373,
            column: 69
          },
          end: {
            line: 373,
            column: 77
          }
        }],
        line: 373
      },
      "61": {
        loc: {
          start: {
            line: 374,
            column: 6
          },
          end: {
            line: 374,
            column: 75
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 374,
            column: 6
          },
          end: {
            line: 374,
            column: 75
          }
        }, {
          start: {
            line: 374,
            column: 6
          },
          end: {
            line: 374,
            column: 75
          }
        }],
        line: 374
      },
      "62": {
        loc: {
          start: {
            line: 380,
            column: 4
          },
          end: {
            line: 383,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 380,
            column: 4
          },
          end: {
            line: 383,
            column: 5
          }
        }, {
          start: {
            line: 380,
            column: 4
          },
          end: {
            line: 383,
            column: 5
          }
        }],
        line: 380
      },
      "63": {
        loc: {
          start: {
            line: 380,
            column: 8
          },
          end: {
            line: 380,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 380,
            column: 8
          },
          end: {
            line: 380,
            column: 16
          }
        }, {
          start: {
            line: 380,
            column: 20
          },
          end: {
            line: 380,
            column: 24
          }
        }, {
          start: {
            line: 380,
            column: 28
          },
          end: {
            line: 380,
            column: 46
          }
        }, {
          start: {
            line: 380,
            column: 50
          },
          end: {
            line: 380,
            column: 67
          }
        }],
        line: 380
      },
      "64": {
        loc: {
          start: {
            line: 384,
            column: 4
          },
          end: {
            line: 384,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 384,
            column: 4
          },
          end: {
            line: 384,
            column: 25
          }
        }, {
          start: {
            line: 384,
            column: 4
          },
          end: {
            line: 384,
            column: 25
          }
        }],
        line: 384
      },
      "65": {
        loc: {
          start: {
            line: 385,
            column: 4
          },
          end: {
            line: 385,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 385,
            column: 4
          },
          end: {
            line: 385,
            column: 33
          }
        }, {
          start: {
            line: 385,
            column: 4
          },
          end: {
            line: 385,
            column: 33
          }
        }],
        line: 385
      },
      "66": {
        loc: {
          start: {
            line: 385,
            column: 8
          },
          end: {
            line: 385,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 385,
            column: 8
          },
          end: {
            line: 385,
            column: 16
          }
        }, {
          start: {
            line: 385,
            column: 20
          },
          end: {
            line: 385,
            column: 25
          }
        }],
        line: 385
      },
      "67": {
        loc: {
          start: {
            line: 387,
            column: 4
          },
          end: {
            line: 387,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 387,
            column: 4
          },
          end: {
            line: 387,
            column: 44
          }
        }, {
          start: {
            line: 387,
            column: 4
          },
          end: {
            line: 387,
            column: 44
          }
        }],
        line: 387
      },
      "68": {
        loc: {
          start: {
            line: 396,
            column: 6
          },
          end: {
            line: 396,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 396,
            column: 6
          },
          end: {
            line: 396,
            column: 46
          }
        }, {
          start: {
            line: 396,
            column: 6
          },
          end: {
            line: 396,
            column: 46
          }
        }],
        line: 396
      },
      "69": {
        loc: {
          start: {
            line: 405,
            column: 4
          },
          end: {
            line: 409,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 405,
            column: 4
          },
          end: {
            line: 409,
            column: 5
          }
        }, {
          start: {
            line: 405,
            column: 4
          },
          end: {
            line: 409,
            column: 5
          }
        }],
        line: 405
      },
      "70": {
        loc: {
          start: {
            line: 415,
            column: 4
          },
          end: {
            line: 418,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 415,
            column: 4
          },
          end: {
            line: 418,
            column: 5
          }
        }, {
          start: {
            line: 415,
            column: 4
          },
          end: {
            line: 418,
            column: 5
          }
        }],
        line: 415
      },
      "71": {
        loc: {
          start: {
            line: 416,
            column: 6
          },
          end: {
            line: 416,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 416,
            column: 6
          },
          end: {
            line: 416,
            column: 44
          }
        }, {
          start: {
            line: 416,
            column: 6
          },
          end: {
            line: 416,
            column: 44
          }
        }],
        line: 416
      },
      "72": {
        loc: {
          start: {
            line: 424,
            column: 23
          },
          end: {
            line: 424,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 424,
            column: 23
          },
          end: {
            line: 424,
            column: 47
          }
        }, {
          start: {
            line: 424,
            column: 51
          },
          end: {
            line: 424,
            column: 77
          }
        }],
        line: 424
      },
      "73": {
        loc: {
          start: {
            line: 425,
            column: 4
          },
          end: {
            line: 428,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 425,
            column: 4
          },
          end: {
            line: 428,
            column: 5
          }
        }, {
          start: {
            line: 425,
            column: 4
          },
          end: {
            line: 428,
            column: 5
          }
        }],
        line: 425
      },
      "74": {
        loc: {
          start: {
            line: 425,
            column: 8
          },
          end: {
            line: 425,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 425,
            column: 8
          },
          end: {
            line: 425,
            column: 16
          }
        }, {
          start: {
            line: 425,
            column: 20
          },
          end: {
            line: 425,
            column: 36
          }
        }, {
          start: {
            line: 425,
            column: 40
          },
          end: {
            line: 425,
            column: 57
          }
        }],
        line: 425
      },
      "75": {
        loc: {
          start: {
            line: 430,
            column: 4
          },
          end: {
            line: 433,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 430,
            column: 4
          },
          end: {
            line: 433,
            column: 5
          }
        }, {
          start: {
            line: 430,
            column: 4
          },
          end: {
            line: 433,
            column: 5
          }
        }],
        line: 430
      },
      "76": {
        loc: {
          start: {
            line: 434,
            column: 4
          },
          end: {
            line: 438,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 434,
            column: 4
          },
          end: {
            line: 438,
            column: 5
          }
        }, {
          start: {
            line: 434,
            column: 4
          },
          end: {
            line: 438,
            column: 5
          }
        }],
        line: 434
      },
      "77": {
        loc: {
          start: {
            line: 434,
            column: 8
          },
          end: {
            line: 434,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 434,
            column: 8
          },
          end: {
            line: 434,
            column: 12
          }
        }, {
          start: {
            line: 434,
            column: 16
          },
          end: {
            line: 434,
            column: 56
          }
        }],
        line: 434
      },
      "78": {
        loc: {
          start: {
            line: 437,
            column: 6
          },
          end: {
            line: 437,
            column: 78
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 437,
            column: 6
          },
          end: {
            line: 437,
            column: 78
          }
        }, {
          start: {
            line: 437,
            column: 6
          },
          end: {
            line: 437,
            column: 78
          }
        }],
        line: 437
      },
      "79": {
        loc: {
          start: {
            line: 445,
            column: 4
          },
          end: {
            line: 453,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 445,
            column: 4
          },
          end: {
            line: 453,
            column: 5
          }
        }, {
          start: {
            line: 445,
            column: 4
          },
          end: {
            line: 453,
            column: 5
          }
        }],
        line: 445
      },
      "80": {
        loc: {
          start: {
            line: 445,
            column: 8
          },
          end: {
            line: 445,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 445,
            column: 9
          },
          end: {
            line: 445,
            column: 25
          }
        }, {
          start: {
            line: 445,
            column: 29
          },
          end: {
            line: 445,
            column: 45
          }
        }, {
          start: {
            line: 445,
            column: 50
          },
          end: {
            line: 445,
            column: 61
          }
        }],
        line: 445
      },
      "81": {
        loc: {
          start: {
            line: 447,
            column: 6
          },
          end: {
            line: 450,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 447,
            column: 6
          },
          end: {
            line: 450,
            column: 7
          }
        }, {
          start: {
            line: 447,
            column: 6
          },
          end: {
            line: 450,
            column: 7
          }
        }],
        line: 447
      },
      "82": {
        loc: {
          start: {
            line: 449,
            column: 8
          },
          end: {
            line: 449,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 449,
            column: 8
          },
          end: {
            line: 449,
            column: 37
          }
        }, {
          start: {
            line: 449,
            column: 8
          },
          end: {
            line: 449,
            column: 37
          }
        }],
        line: 449
      },
      "83": {
        loc: {
          start: {
            line: 456,
            column: 4
          },
          end: {
            line: 462,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 456,
            column: 4
          },
          end: {
            line: 462,
            column: 5
          }
        }, {
          start: {
            line: 456,
            column: 4
          },
          end: {
            line: 462,
            column: 5
          }
        }],
        line: 456
      },
      "84": {
        loc: {
          start: {
            line: 459,
            column: 6
          },
          end: {
            line: 460,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 459,
            column: 6
          },
          end: {
            line: 460,
            column: 32
          }
        }, {
          start: {
            line: 459,
            column: 6
          },
          end: {
            line: 460,
            column: 32
          }
        }],
        line: 459
      },
      "85": {
        loc: {
          start: {
            line: 465,
            column: 4
          },
          end: {
            line: 465,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 465,
            column: 4
          },
          end: {
            line: 465,
            column: 27
          }
        }, {
          start: {
            line: 465,
            column: 4
          },
          end: {
            line: 465,
            column: 27
          }
        }],
        line: 465
      },
      "86": {
        loc: {
          start: {
            line: 469,
            column: 4
          },
          end: {
            line: 488,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 470,
            column: 6
          },
          end: {
            line: 473,
            column: 13
          }
        }, {
          start: {
            line: 474,
            column: 6
          },
          end: {
            line: 477,
            column: 13
          }
        }, {
          start: {
            line: 478,
            column: 6
          },
          end: {
            line: 482,
            column: 13
          }
        }, {
          start: {
            line: 483,
            column: 6
          },
          end: {
            line: 485,
            column: 13
          }
        }, {
          start: {
            line: 486,
            column: 6
          },
          end: {
            line: 487,
            column: 44
          }
        }],
        line: 469
      },
      "87": {
        loc: {
          start: {
            line: 471,
            column: 8
          },
          end: {
            line: 471,
            column: 68
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 471,
            column: 8
          },
          end: {
            line: 471,
            column: 68
          }
        }, {
          start: {
            line: 471,
            column: 8
          },
          end: {
            line: 471,
            column: 68
          }
        }],
        line: 471
      },
      "88": {
        loc: {
          start: {
            line: 475,
            column: 8
          },
          end: {
            line: 475,
            column: 67
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 475,
            column: 8
          },
          end: {
            line: 475,
            column: 67
          }
        }, {
          start: {
            line: 475,
            column: 8
          },
          end: {
            line: 475,
            column: 67
          }
        }],
        line: 475
      },
      "89": {
        loc: {
          start: {
            line: 496,
            column: 4
          },
          end: {
            line: 498,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 496,
            column: 4
          },
          end: {
            line: 498,
            column: 5
          }
        }, {
          start: {
            line: 496,
            column: 4
          },
          end: {
            line: 498,
            column: 5
          }
        }],
        line: 496
      },
      "90": {
        loc: {
          start: {
            line: 506,
            column: 4
          },
          end: {
            line: 506,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 506,
            column: 4
          },
          end: {
            line: 506,
            column: 25
          }
        }, {
          start: {
            line: 506,
            column: 4
          },
          end: {
            line: 506,
            column: 25
          }
        }],
        line: 506
      },
      "91": {
        loc: {
          start: {
            line: 507,
            column: 4
          },
          end: {
            line: 511,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 507,
            column: 4
          },
          end: {
            line: 511,
            column: 5
          }
        }, {
          start: {
            line: 507,
            column: 4
          },
          end: {
            line: 511,
            column: 5
          }
        }],
        line: 507
      },
      "92": {
        loc: {
          start: {
            line: 509,
            column: 11
          },
          end: {
            line: 511,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 509,
            column: 11
          },
          end: {
            line: 511,
            column: 5
          }
        }, {
          start: {
            line: 509,
            column: 11
          },
          end: {
            line: 511,
            column: 5
          }
        }],
        line: 509
      },
      "93": {
        loc: {
          start: {
            line: 512,
            column: 4
          },
          end: {
            line: 512,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 512,
            column: 4
          },
          end: {
            line: 512,
            column: 44
          }
        }, {
          start: {
            line: 512,
            column: 4
          },
          end: {
            line: 512,
            column: 44
          }
        }],
        line: 512
      },
      "94": {
        loc: {
          start: {
            line: 512,
            column: 8
          },
          end: {
            line: 512,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 512,
            column: 8
          },
          end: {
            line: 512,
            column: 17
          }
        }, {
          start: {
            line: 512,
            column: 21
          },
          end: {
            line: 512,
            column: 36
          }
        }],
        line: 512
      },
      "95": {
        loc: {
          start: {
            line: 513,
            column: 4
          },
          end: {
            line: 513,
            column: 65
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 513,
            column: 4
          },
          end: {
            line: 513,
            column: 65
          }
        }, {
          start: {
            line: 513,
            column: 4
          },
          end: {
            line: 513,
            column: 65
          }
        }],
        line: 513
      },
      "96": {
        loc: {
          start: {
            line: 513,
            column: 8
          },
          end: {
            line: 513,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 513,
            column: 8
          },
          end: {
            line: 513,
            column: 14
          }
        }, {
          start: {
            line: 513,
            column: 19
          },
          end: {
            line: 513,
            column: 39
          }
        }, {
          start: {
            line: 513,
            column: 43
          },
          end: {
            line: 513,
            column: 56
          }
        }],
        line: 513
      },
      "97": {
        loc: {
          start: {
            line: 515,
            column: 17
          },
          end: {
            line: 515,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 515,
            column: 40
          },
          end: {
            line: 515,
            column: 45
          }
        }, {
          start: {
            line: 515,
            column: 48
          },
          end: {
            line: 515,
            column: 55
          }
        }],
        line: 515
      },
      "98": {
        loc: {
          start: {
            line: 517,
            column: 4
          },
          end: {
            line: 527,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 517,
            column: 4
          },
          end: {
            line: 527,
            column: 5
          }
        }, {
          start: {
            line: 517,
            column: 4
          },
          end: {
            line: 527,
            column: 5
          }
        }],
        line: 517
      },
      "99": {
        loc: {
          start: {
            line: 521,
            column: 8
          },
          end: {
            line: 525,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 521,
            column: 8
          },
          end: {
            line: 525,
            column: 9
          }
        }, {
          start: {
            line: 521,
            column: 8
          },
          end: {
            line: 525,
            column: 9
          }
        }],
        line: 521
      },
      "100": {
        loc: {
          start: {
            line: 532,
            column: 23
          },
          end: {
            line: 532,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 532,
            column: 23
          },
          end: {
            line: 532,
            column: 31
          }
        }, {
          start: {
            line: 532,
            column: 35
          },
          end: {
            line: 532,
            column: 51
          }
        }],
        line: 532
      },
      "101": {
        loc: {
          start: {
            line: 533,
            column: 4
          },
          end: {
            line: 536,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 533,
            column: 4
          },
          end: {
            line: 536,
            column: 5
          }
        }, {
          start: {
            line: 533,
            column: 4
          },
          end: {
            line: 536,
            column: 5
          }
        }],
        line: 533
      },
      "102": {
        loc: {
          start: {
            line: 533,
            column: 8
          },
          end: {
            line: 533,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 533,
            column: 8
          },
          end: {
            line: 533,
            column: 16
          }
        }, {
          start: {
            line: 533,
            column: 20
          },
          end: {
            line: 533,
            column: 37
          }
        }],
        line: 533
      },
      "103": {
        loc: {
          start: {
            line: 535,
            column: 6
          },
          end: {
            line: 535,
            column: 75
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 535,
            column: 6
          },
          end: {
            line: 535,
            column: 75
          }
        }, {
          start: {
            line: 535,
            column: 6
          },
          end: {
            line: 535,
            column: 75
          }
        }],
        line: 535
      },
      "104": {
        loc: {
          start: {
            line: 537,
            column: 4
          },
          end: {
            line: 539,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 537,
            column: 4
          },
          end: {
            line: 539,
            column: 5
          }
        }, {
          start: {
            line: 537,
            column: 4
          },
          end: {
            line: 539,
            column: 5
          }
        }],
        line: 537
      },
      "105": {
        loc: {
          start: {
            line: 538,
            column: 6
          },
          end: {
            line: 538,
            column: 76
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 538,
            column: 6
          },
          end: {
            line: 538,
            column: 76
          }
        }, {
          start: {
            line: 538,
            column: 6
          },
          end: {
            line: 538,
            column: 76
          }
        }],
        line: 538
      },
      "106": {
        loc: {
          start: {
            line: 540,
            column: 4
          },
          end: {
            line: 542,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 540,
            column: 4
          },
          end: {
            line: 542,
            column: 5
          }
        }, {
          start: {
            line: 540,
            column: 4
          },
          end: {
            line: 542,
            column: 5
          }
        }],
        line: 540
      },
      "107": {
        loc: {
          start: {
            line: 547,
            column: 11
          },
          end: {
            line: 549,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 548,
            column: 8
          },
          end: {
            line: 548,
            column: 31
          }
        }, {
          start: {
            line: 549,
            column: 9
          },
          end: {
            line: 549,
            column: 65
          }
        }],
        line: 547
      },
      "108": {
        loc: {
          start: {
            line: 554,
            column: 4
          },
          end: {
            line: 554,
            column: 58
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 554,
            column: 4
          },
          end: {
            line: 554,
            column: 58
          }
        }, {
          start: {
            line: 554,
            column: 4
          },
          end: {
            line: 554,
            column: 58
          }
        }],
        line: 554
      },
      "109": {
        loc: {
          start: {
            line: 555,
            column: 11
          },
          end: {
            line: 555,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 555,
            column: 48
          },
          end: {
            line: 555,
            column: 73
          }
        }, {
          start: {
            line: 555,
            column: 76
          },
          end: {
            line: 555,
            column: 94
          }
        }],
        line: 555
      },
      "110": {
        loc: {
          start: {
            line: 563,
            column: 4
          },
          end: {
            line: 563,
            column: 105
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 563,
            column: 4
          },
          end: {
            line: 563,
            column: 105
          }
        }, {
          start: {
            line: 563,
            column: 4
          },
          end: {
            line: 563,
            column: 105
          }
        }],
        line: 563
      },
      "111": {
        loc: {
          start: {
            line: 593,
            column: 39
          },
          end: {
            line: 593,
            column: 115
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 593,
            column: 53
          },
          end: {
            line: 593,
            column: 93
          }
        }, {
          start: {
            line: 593,
            column: 96
          },
          end: {
            line: 593,
            column: 115
          }
        }],
        line: 593
      },
      "112": {
        loc: {
          start: {
            line: 599,
            column: 41
          },
          end: {
            line: 599,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 599,
            column: 41
          },
          end: {
            line: 599,
            column: 48
          }
        }, {
          start: {
            line: 599,
            column: 52
          },
          end: {
            line: 599,
            column: 57
          }
        }],
        line: 599
      },
      "113": {
        loc: {
          start: {
            line: 623,
            column: 19
          },
          end: {
            line: 623,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 623,
            column: 19
          },
          end: {
            line: 623,
            column: 41
          }
        }, {
          start: {
            line: 623,
            column: 45
          },
          end: {
            line: 623,
            column: 69
          }
        }],
        line: 623
      },
      "114": {
        loc: {
          start: {
            line: 625,
            column: 18
          },
          end: {
            line: 625,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 625,
            column: 18
          },
          end: {
            line: 625,
            column: 39
          }
        }, {
          start: {
            line: 625,
            column: 43
          },
          end: {
            line: 625,
            column: 66
          }
        }],
        line: 625
      },
      "115": {
        loc: {
          start: {
            line: 626,
            column: 14
          },
          end: {
            line: 626,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 626,
            column: 14
          },
          end: {
            line: 626,
            column: 31
          }
        }, {
          start: {
            line: 626,
            column: 35
          },
          end: {
            line: 626,
            column: 54
          }
        }],
        line: 626
      },
      "116": {
        loc: {
          start: {
            line: 636,
            column: 39
          },
          end: {
            line: 636,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 636,
            column: 53
          },
          end: {
            line: 636,
            column: 75
          }
        }, {
          start: {
            line: 636,
            column: 78
          },
          end: {
            line: 636,
            column: 80
          }
        }],
        line: 636
      },
      "117": {
        loc: {
          start: {
            line: 637,
            column: 4
          },
          end: {
            line: 658,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 637,
            column: 4
          },
          end: {
            line: 658,
            column: 5
          }
        }, {
          start: {
            line: 637,
            column: 4
          },
          end: {
            line: 658,
            column: 5
          }
        }],
        line: 637
      },
      "118": {
        loc: {
          start: {
            line: 637,
            column: 8
          },
          end: {
            line: 637,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 637,
            column: 9
          },
          end: {
            line: 637,
            column: 42
          }
        }, {
          start: {
            line: 637,
            column: 46
          },
          end: {
            line: 637,
            column: 65
          }
        }, {
          start: {
            line: 637,
            column: 70
          },
          end: {
            line: 637,
            column: 90
          }
        }],
        line: 637
      },
      "119": {
        loc: {
          start: {
            line: 643,
            column: 43
          },
          end: {
            line: 643,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 643,
            column: 43
          },
          end: {
            line: 643,
            column: 50
          }
        }, {
          start: {
            line: 643,
            column: 54
          },
          end: {
            line: 643,
            column: 59
          }
        }],
        line: 643
      },
      "120": {
        loc: {
          start: {
            line: 644,
            column: 33
          },
          end: {
            line: 644,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 644,
            column: 33
          },
          end: {
            line: 644,
            column: 42
          }
        }, {
          start: {
            line: 644,
            column: 46
          },
          end: {
            line: 644,
            column: 58
          }
        }],
        line: 644
      },
      "121": {
        loc: {
          start: {
            line: 653,
            column: 17
          },
          end: {
            line: 653,
            column: 41
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 653,
            column: 29
          },
          end: {
            line: 653,
            column: 34
          }
        }, {
          start: {
            line: 653,
            column: 37
          },
          end: {
            line: 653,
            column: 41
          }
        }],
        line: 653
      },
      "122": {
        loc: {
          start: {
            line: 664,
            column: 41
          },
          end: {
            line: 664,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 664,
            column: 41
          },
          end: {
            line: 664,
            column: 48
          }
        }, {
          start: {
            line: 664,
            column: 52
          },
          end: {
            line: 664,
            column: 57
          }
        }],
        line: 664
      },
      "123": {
        loc: {
          start: {
            line: 665,
            column: 31
          },
          end: {
            line: 665,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 665,
            column: 31
          },
          end: {
            line: 665,
            column: 40
          }
        }, {
          start: {
            line: 665,
            column: 44
          },
          end: {
            line: 665,
            column: 56
          }
        }],
        line: 665
      },
      "124": {
        loc: {
          start: {
            line: 676,
            column: 15
          },
          end: {
            line: 676,
            column: 39
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 676,
            column: 27
          },
          end: {
            line: 676,
            column: 32
          }
        }, {
          start: {
            line: 676,
            column: 35
          },
          end: {
            line: 676,
            column: 39
          }
        }],
        line: 676
      },
      "125": {
        loc: {
          start: {
            line: 685,
            column: 4
          },
          end: {
            line: 685,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 685,
            column: 4
          },
          end: {
            line: 685,
            column: 42
          }
        }, {
          start: {
            line: 685,
            column: 4
          },
          end: {
            line: 685,
            column: 42
          }
        }],
        line: 685
      },
      "126": {
        loc: {
          start: {
            line: 709,
            column: 6
          },
          end: {
            line: 709,
            column: 30
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 709,
            column: 13
          },
          end: {
            line: 709,
            column: 30
          }
        }],
        line: 709
      },
      "127": {
        loc: {
          start: {
            line: 717,
            column: 6
          },
          end: {
            line: 717,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 717,
            column: 6
          },
          end: {
            line: 717,
            column: 16
          }
        }, {
          start: {
            line: 717,
            column: 20
          },
          end: {
            line: 717,
            column: 27
          }
        }],
        line: 717
      },
      "128": {
        loc: {
          start: {
            line: 719,
            column: 6
          },
          end: {
            line: 719,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 719,
            column: 6
          },
          end: {
            line: 719,
            column: 14
          }
        }, {
          start: {
            line: 719,
            column: 18
          },
          end: {
            line: 719,
            column: 28
          }
        }],
        line: 719
      },
      "129": {
        loc: {
          start: {
            line: 720,
            column: 6
          },
          end: {
            line: 720,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 720,
            column: 6
          },
          end: {
            line: 720,
            column: 23
          }
        }, {
          start: {
            line: 720,
            column: 27
          },
          end: {
            line: 720,
            column: 56
          }
        }],
        line: 720
      },
      "130": {
        loc: {
          start: {
            line: 721,
            column: 6
          },
          end: {
            line: 721,
            column: 20
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 721,
            column: 6
          },
          end: {
            line: 721,
            column: 11
          }
        }, {
          start: {
            line: 721,
            column: 15
          },
          end: {
            line: 721,
            column: 20
          }
        }],
        line: 721
      },
      "131": {
        loc: {
          start: {
            line: 726,
            column: 18
          },
          end: {
            line: 726,
            column: 44
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 726,
            column: 38
          },
          end: {
            line: 726,
            column: 40
          }
        }, {
          start: {
            line: 726,
            column: 43
          },
          end: {
            line: 726,
            column: 44
          }
        }],
        line: 726
      },
      "132": {
        loc: {
          start: {
            line: 739,
            column: 19
          },
          end: {
            line: 739,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 739,
            column: 31
          },
          end: {
            line: 739,
            column: 47
          }
        }, {
          start: {
            line: 739,
            column: 50
          },
          end: {
            line: 739,
            column: 59
          }
        }],
        line: 739
      },
      "133": {
        loc: {
          start: {
            line: 742,
            column: 20
          },
          end: {
            line: 742,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 742,
            column: 31
          },
          end: {
            line: 742,
            column: 48
          }
        }, {
          start: {
            line: 742,
            column: 51
          },
          end: {
            line: 742,
            column: 60
          }
        }],
        line: 742
      },
      "134": {
        loc: {
          start: {
            line: 765,
            column: 16
          },
          end: {
            line: 765,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 765,
            column: 16
          },
          end: {
            line: 765,
            column: 24
          }
        }, {
          start: {
            line: 765,
            column: 28
          },
          end: {
            line: 765,
            column: 32
          }
        }],
        line: 765
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0,
      "162": 0,
      "163": 0,
      "164": 0,
      "165": 0,
      "166": 0,
      "167": 0,
      "168": 0,
      "169": 0,
      "170": 0,
      "171": 0,
      "172": 0,
      "173": 0,
      "174": 0,
      "175": 0,
      "176": 0,
      "177": 0,
      "178": 0,
      "179": 0,
      "180": 0,
      "181": 0,
      "182": 0,
      "183": 0,
      "184": 0,
      "185": 0,
      "186": 0,
      "187": 0,
      "188": 0,
      "189": 0,
      "190": 0,
      "191": 0,
      "192": 0,
      "193": 0,
      "194": 0,
      "195": 0,
      "196": 0,
      "197": 0,
      "198": 0,
      "199": 0,
      "200": 0,
      "201": 0,
      "202": 0,
      "203": 0,
      "204": 0,
      "205": 0,
      "206": 0,
      "207": 0,
      "208": 0,
      "209": 0,
      "210": 0,
      "211": 0,
      "212": 0,
      "213": 0,
      "214": 0,
      "215": 0,
      "216": 0,
      "217": 0,
      "218": 0,
      "219": 0,
      "220": 0,
      "221": 0,
      "222": 0,
      "223": 0,
      "224": 0,
      "225": 0,
      "226": 0,
      "227": 0,
      "228": 0,
      "229": 0,
      "230": 0,
      "231": 0,
      "232": 0,
      "233": 0,
      "234": 0,
      "235": 0,
      "236": 0,
      "237": 0,
      "238": 0,
      "239": 0,
      "240": 0,
      "241": 0,
      "242": 0,
      "243": 0,
      "244": 0,
      "245": 0,
      "246": 0,
      "247": 0,
      "248": 0,
      "249": 0,
      "250": 0,
      "251": 0,
      "252": 0,
      "253": 0,
      "254": 0,
      "255": 0,
      "256": 0,
      "257": 0,
      "258": 0,
      "259": 0,
      "260": 0,
      "261": 0,
      "262": 0,
      "263": 0,
      "264": 0,
      "265": 0,
      "266": 0,
      "267": 0,
      "268": 0,
      "269": 0,
      "270": 0,
      "271": 0,
      "272": 0,
      "273": 0,
      "274": 0,
      "275": 0,
      "276": 0,
      "277": 0,
      "278": 0,
      "279": 0,
      "280": 0,
      "281": 0,
      "282": 0,
      "283": 0,
      "284": 0,
      "285": 0,
      "286": 0,
      "287": 0,
      "288": 0,
      "289": 0,
      "290": 0,
      "291": 0,
      "292": 0,
      "293": 0,
      "294": 0,
      "295": 0,
      "296": 0,
      "297": 0,
      "298": 0,
      "299": 0,
      "300": 0,
      "301": 0,
      "302": 0,
      "303": 0,
      "304": 0,
      "305": 0,
      "306": 0,
      "307": 0,
      "308": 0,
      "309": 0,
      "310": 0,
      "311": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0, 0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0, 0],
      "30": [0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0, 0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0, 0],
      "58": [0, 0],
      "59": [0, 0],
      "60": [0, 0, 0],
      "61": [0, 0],
      "62": [0, 0],
      "63": [0, 0, 0, 0],
      "64": [0, 0],
      "65": [0, 0],
      "66": [0, 0],
      "67": [0, 0],
      "68": [0, 0],
      "69": [0, 0],
      "70": [0, 0],
      "71": [0, 0],
      "72": [0, 0],
      "73": [0, 0],
      "74": [0, 0, 0],
      "75": [0, 0],
      "76": [0, 0],
      "77": [0, 0],
      "78": [0, 0],
      "79": [0, 0],
      "80": [0, 0, 0],
      "81": [0, 0],
      "82": [0, 0],
      "83": [0, 0],
      "84": [0, 0],
      "85": [0, 0],
      "86": [0, 0, 0, 0, 0],
      "87": [0, 0],
      "88": [0, 0],
      "89": [0, 0],
      "90": [0, 0],
      "91": [0, 0],
      "92": [0, 0],
      "93": [0, 0],
      "94": [0, 0],
      "95": [0, 0],
      "96": [0, 0, 0],
      "97": [0, 0],
      "98": [0, 0],
      "99": [0, 0],
      "100": [0, 0],
      "101": [0, 0],
      "102": [0, 0],
      "103": [0, 0],
      "104": [0, 0],
      "105": [0, 0],
      "106": [0, 0],
      "107": [0, 0],
      "108": [0, 0],
      "109": [0, 0],
      "110": [0, 0],
      "111": [0, 0],
      "112": [0, 0],
      "113": [0, 0],
      "114": [0, 0],
      "115": [0, 0],
      "116": [0, 0],
      "117": [0, 0],
      "118": [0, 0, 0],
      "119": [0, 0],
      "120": [0, 0],
      "121": [0, 0],
      "122": [0, 0],
      "123": [0, 0],
      "124": [0, 0],
      "125": [0, 0],
      "126": [0],
      "127": [0, 0],
      "128": [0, 0],
      "129": [0, 0],
      "130": [0, 0],
      "131": [0, 0],
      "132": [0, 0],
      "133": [0, 0],
      "134": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Select/Select.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { SUBMIT_TOPIC } from '../Datum/types';
import { PureComponent } from '../component';
import { getUidStr } from '../utils/uid';
import { selectClass } from './styles';
import Result from './Result';
import OptionList from './OptionList';
import OptionTree from './OptionTree';
import BoxList from './BoxList';
import { isObject, isFunc } from '../utils/is';
import { docSize } from '../utils/dom/document';
import { getParent } from '../utils/dom/element';
import { isRTL } from '../config';
import absoluteList from '../AnimationList/AbsoluteList';
import { getDirectionClass } from '../utils/classname';
var WrappedOptionList = (cov_2bjjvvfkcg.s[0]++, absoluteList(OptionList));
var WrappedBoxList = (cov_2bjjvvfkcg.s[1]++, absoluteList(BoxList));
var WrappedOptionTree = (cov_2bjjvvfkcg.s[2]++, absoluteList(OptionTree));
cov_2bjjvvfkcg.s[3]++;

var isResult = function isResult(el, selector) {
  cov_2bjjvvfkcg.f[0]++;
  cov_2bjjvvfkcg.s[4]++;
  return getParent(el, (cov_2bjjvvfkcg.b[0][0]++, selector) || (cov_2bjjvvfkcg.b[0][1]++, ".".concat(selectClass('result'))));
};

var DefaultValue = (cov_2bjjvvfkcg.s[5]++, {
  clearable: false,
  data: [],
  height: 250,
  itemsInView: 10,
  lineHeight: 34,
  loading: false,
  multiple: false,
  renderItem: function renderItem(e) {
    cov_2bjjvvfkcg.f[1]++;
    cov_2bjjvvfkcg.s[6]++;
    return e;
  },
  text: {},
  compressed: false,
  trim: true,
  autoAdapt: false,
  showArrow: true,
  focusSelected: true
});

var Select =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Select, _PureComponent);

  var _super = _createSuper2(Select);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    cov_2bjjvvfkcg.f[2]++;
    cov_2bjjvvfkcg.s[7]++;
    _this = _super.call(this, props);
    _this.blurHandler = void 0;
    _this.renderPending = void 0;
    _this.optionList = void 0;
    _this.selectId = void 0;
    _this.mouseDown = void 0;
    _this.lastResult = void 0;
    _this.lastFoucs = void 0;
    _this.focusInput = void 0;
    _this.inputReset = void 0;
    _this.element = void 0;
    _this.blured = void 0;
    _this.inputBlurTimer = void 0;
    _this.lastChangeIsOptionClick = void 0;
    _this.handleRemove = void 0;
    _this.inputLocked = void 0;
    _this.keyLocked = void 0;
    _this.cancelDeleteLockTimer = void 0;
    _this.deleteLock = void 0;

    _this.forceChange = function () {
      cov_2bjjvvfkcg.f[12]++;
      cov_2bjjvvfkcg.s[68]++;

      if ((cov_2bjjvvfkcg.b[14][0]++, _this.inputBlurTimer) && (cov_2bjjvvfkcg.b[14][1]++, _this.blurHandler)) {
        cov_2bjjvvfkcg.b[13][0]++;
        cov_2bjjvvfkcg.s[69]++;
        clearTimeout(_this.inputBlurTimer);
        cov_2bjjvvfkcg.s[70]++;

        _this.blurHandler();
      } else {
        cov_2bjjvvfkcg.b[13][1]++;
      }
    };

    cov_2bjjvvfkcg.s[8]++;
    _this.state = {
      control: 'mouse',
      focus: false,
      position: 'drop-down'
    };
    cov_2bjjvvfkcg.s[9]++;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    cov_2bjjvvfkcg.s[10]++;
    _this.bindOptionFunc = _this.bindOptionFunc.bind(_assertThisInitialized(_this));
    cov_2bjjvvfkcg.s[11]++;
    _this.setInputReset = _this.setInputReset.bind(_assertThisInitialized(_this));
    cov_2bjjvvfkcg.s[12]++;
    _this.shouldFocus = _this.shouldFocus.bind(_assertThisInitialized(_this));
    cov_2bjjvvfkcg.s[13]++;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    cov_2bjjvvfkcg.s[14]++;
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    cov_2bjjvvfkcg.s[15]++;
    _this.handleClear = _this.handleClear.bind(_assertThisInitialized(_this));
    cov_2bjjvvfkcg.s[16]++;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    cov_2bjjvvfkcg.s[17]++;
    _this.handleRemove = _this.handleChange.bind(_assertThisInitialized(_this), false);
    cov_2bjjvvfkcg.s[18]++;
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    cov_2bjjvvfkcg.s[19]++;
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_this));
    cov_2bjjvvfkcg.s[20]++;
    _this.handleInputFocus = _this.handleInputFocus.bind(_assertThisInitialized(_this));
    cov_2bjjvvfkcg.s[21]++;
    _this.handleControlChange = _this.handleControlChange.bind(_assertThisInitialized(_this));
    cov_2bjjvvfkcg.s[22]++;
    _this.handleClickAway = _this.handleClickAway.bind(_assertThisInitialized(_this));
    cov_2bjjvvfkcg.s[23]++;
    _this.handleInputBlur = _this.handleInputBlur.bind(_assertThisInitialized(_this));
    cov_2bjjvvfkcg.s[24]++;
    _this.bindFocusInputFunc = _this.bindFocusInputFunc.bind(_assertThisInitialized(_this));
    cov_2bjjvvfkcg.s[25]++;
    _this.handleFilter = _this.handleFilter.bind(_assertThisInitialized(_this)); // this.toInputTriggerCollapse = this.toInputTriggerCollapse.bind(this)

    cov_2bjjvvfkcg.s[26]++;
    _this.renderItem = _this.renderItem.bind(_assertThisInitialized(_this));
    cov_2bjjvvfkcg.s[27]++;
    _this.renderResult = _this.renderResult.bind(_assertThisInitialized(_this));
    cov_2bjjvvfkcg.s[28]++;
    _this.handleDelete = _this.handleDelete.bind(_assertThisInitialized(_this)); // option list not render till first focused

    cov_2bjjvvfkcg.s[29]++;
    _this.renderPending = props.open !== true;
    cov_2bjjvvfkcg.s[30]++;
    _this.optionList = {};
    cov_2bjjvvfkcg.s[31]++;
    _this.selectId = "select_".concat(getUidStr()); // this.closeByResult = false

    cov_2bjjvvfkcg.s[32]++;
    _this.mouseDown = false; // this.lastResult = undefined

    cov_2bjjvvfkcg.s[33]++;
    _this.focusInput = null;
    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_2bjjvvfkcg.f[3]++;
      cov_2bjjvvfkcg.s[34]++;

      _get(_getPrototypeOf(Select.prototype), "componentDidMount", this).call(this);

      cov_2bjjvvfkcg.s[35]++;
      this.setOpenEvent();

      var _ref = (cov_2bjjvvfkcg.s[36]++, this.props),
          formDatum = _ref.formDatum;

      cov_2bjjvvfkcg.s[37]++;

      if (formDatum) {
        cov_2bjjvvfkcg.b[1][0]++;
        cov_2bjjvvfkcg.s[38]++;
        formDatum.subscribe(SUBMIT_TOPIC, this.forceChange);
      } else {
        cov_2bjjvvfkcg.b[1][1]++;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      cov_2bjjvvfkcg.f[4]++;
      cov_2bjjvvfkcg.s[39]++;
      this.setOpenEvent();

      var _ref2 = (cov_2bjjvvfkcg.s[40]++, this.props),
          onFilter = _ref2.onFilter; // clear filter


      cov_2bjjvvfkcg.s[41]++;

      if (onFilter) {
        cov_2bjjvvfkcg.b[2][0]++;
        cov_2bjjvvfkcg.s[42]++;

        if ((cov_2bjjvvfkcg.b[4][0]++, prevState.focus !== this.state.focus) && (cov_2bjjvvfkcg.b[4][1]++, !this.state.focus) || (cov_2bjjvvfkcg.b[4][2]++, prevProps.open !== this.props.open) && (cov_2bjjvvfkcg.b[4][3]++, !this.props.open)) {
          cov_2bjjvvfkcg.b[3][0]++;
          cov_2bjjvvfkcg.s[43]++;
          setTimeout(function () {
            cov_2bjjvvfkcg.f[5]++;
            cov_2bjjvvfkcg.s[44]++;
            onFilter('');
          }, 400);
        } else {
          cov_2bjjvvfkcg.b[3][1]++;
        }
      } else {
        cov_2bjjvvfkcg.b[2][1]++;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_2bjjvvfkcg.f[6]++;
      cov_2bjjvvfkcg.s[45]++;

      _get(_getPrototypeOf(Select.prototype), "componentWillUnmount", this).call(this);

      var _ref3 = (cov_2bjjvvfkcg.s[46]++, this.props),
          formDatum = _ref3.formDatum;

      cov_2bjjvvfkcg.s[47]++;

      if (formDatum) {
        cov_2bjjvvfkcg.b[5][0]++;
        cov_2bjjvvfkcg.s[48]++;
        formDatum.unsubscribe(SUBMIT_TOPIC, this.forceChange);
      } else {
        cov_2bjjvvfkcg.b[5][1]++;
      }

      cov_2bjjvvfkcg.s[49]++;
      this.clearClickAway();
    }
  }, {
    key: "setOpenEvent",
    value: function setOpenEvent() {
      cov_2bjjvvfkcg.f[8]++;
      var focus = (cov_2bjjvvfkcg.s[53]++, (cov_2bjjvvfkcg.b[7][0]++, this.focus) || (cov_2bjjvvfkcg.b[7][1]++, this.props.inputFocus));
      cov_2bjjvvfkcg.s[54]++;

      if (this.lastFoucs !== focus) {
        cov_2bjjvvfkcg.b[8][0]++;
        cov_2bjjvvfkcg.s[55]++;

        if (focus) {
          cov_2bjjvvfkcg.b[9][0]++;
          cov_2bjjvvfkcg.s[56]++;
          this.bindClickAway();
        } else {
          cov_2bjjvvfkcg.b[9][1]++;
          cov_2bjjvvfkcg.s[57]++;

          if (this.lastFoucs !== undefined) {
            cov_2bjjvvfkcg.b[10][0]++;
            cov_2bjjvvfkcg.s[58]++;
            this.clearClickAway();
          } else {
            cov_2bjjvvfkcg.b[10][1]++;
          }
        }
      } else {
        cov_2bjjvvfkcg.b[8][1]++;
      }

      cov_2bjjvvfkcg.s[59]++;
      this.lastFoucs = focus;
    }
  }, {
    key: "getDisabledStatus",
    value: function getDisabledStatus() {
      cov_2bjjvvfkcg.f[9]++;
      cov_2bjjvvfkcg.s[60]++;

      if (typeof this.props.disabled === 'function') {
        cov_2bjjvvfkcg.b[11][0]++;
        cov_2bjjvvfkcg.s[61]++;
        return this.props.disabled;
      } else {
        cov_2bjjvvfkcg.b[11][1]++;
      }

      cov_2bjjvvfkcg.s[62]++;
      return !!this.props.disabled;
    }
  }, {
    key: "getFocusSelected",
    value: function getFocusSelected() {
      cov_2bjjvvfkcg.f[10]++;

      var _ref4 = (cov_2bjjvvfkcg.s[63]++, this.props),
          reFocus = _ref4.reFocus,
          focusSelected = _ref4.focusSelected;

      cov_2bjjvvfkcg.s[64]++;

      if (reFocus) {
        cov_2bjjvvfkcg.b[12][0]++;
        cov_2bjjvvfkcg.s[65]++;
        return false;
      } else {
        cov_2bjjvvfkcg.b[12][1]++;
      }

      cov_2bjjvvfkcg.s[66]++;
      return focusSelected;
    }
  }, {
    key: "setInputReset",
    value: function setInputReset(fn) {
      cov_2bjjvvfkcg.f[11]++;
      cov_2bjjvvfkcg.s[67]++;
      this.inputReset = fn;
    }
  }, {
    key: "isDescendent",
    // @ts-ignore
    value: function isDescendent(el, id) {
      cov_2bjjvvfkcg.f[13]++;
      cov_2bjjvvfkcg.s[71]++;

      // const stay = el.classList.contains(selectClass('input')) || el.classList.contains(selectClass('item'))
      // if (stay) this.optionsHold = true
      // if (el.classList.contains(selectClass('result')) && this.optionsHold === null && this.state.focus) {
      //   this.closeByResult = true
      //   this.optionsHold = false
      // }
      if (el.getAttribute('data-id') === id) {
        cov_2bjjvvfkcg.b[15][0]++;
        cov_2bjjvvfkcg.s[72]++;
        return true;
      } else {
        cov_2bjjvvfkcg.b[15][1]++;
      } // in label


      cov_2bjjvvfkcg.s[73]++;

      if ((cov_2bjjvvfkcg.b[17][0]++, el.tagName === 'LABEL') && (cov_2bjjvvfkcg.b[17][1]++, el.htmlFor) && (cov_2bjjvvfkcg.b[17][2]++, el.contains(this.element)) && (cov_2bjjvvfkcg.b[17][3]++, el.contains(document.getElementById(el.htmlFor)))) {
        cov_2bjjvvfkcg.b[16][0]++;
        cov_2bjjvvfkcg.s[74]++;
        return true;
      } else {
        cov_2bjjvvfkcg.b[16][1]++;
      }

      cov_2bjjvvfkcg.s[75]++;

      if (!el.parentElement) {
        cov_2bjjvvfkcg.b[18][0]++;
        cov_2bjjvvfkcg.s[76]++;
        return false;
      } else {
        cov_2bjjvvfkcg.b[18][1]++;
      }

      cov_2bjjvvfkcg.s[77]++;
      return this.isDescendent(el.parentElement, id);
    }
  }, {
    key: "bindOptionFunc",
    value: function bindOptionFunc(name, fn) {
      cov_2bjjvvfkcg.f[14]++;
      cov_2bjjvvfkcg.s[78]++;
      this.optionList[name] = fn;
    }
  }, {
    key: "bindFocusInputFunc",
    value: function bindFocusInputFunc(fn) {
      cov_2bjjvvfkcg.f[15]++;
      cov_2bjjvvfkcg.s[79]++;
      this.focusInput = fn;
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      cov_2bjjvvfkcg.f[16]++;
      cov_2bjjvvfkcg.s[80]++;
      this.element = el;
    }
  }, {
    key: "bindClickAway",
    value: function bindClickAway() {
      cov_2bjjvvfkcg.f[17]++;
      cov_2bjjvvfkcg.s[81]++;
      document.addEventListener('click', this.handleClickAway, true);
    }
  }, {
    key: "clearClickAway",
    value: function clearClickAway() {
      cov_2bjjvvfkcg.f[18]++;
      cov_2bjjvvfkcg.s[82]++;
      document.removeEventListener('click', this.handleClickAway, true);
    }
  }, {
    key: "handleClickAway",
    value: function handleClickAway(e) {
      cov_2bjjvvfkcg.f[19]++;
      var desc = (cov_2bjjvvfkcg.s[83]++, this.isDescendent(e.target, this.selectId));
      cov_2bjjvvfkcg.s[84]++;

      if (!desc) {
        cov_2bjjvvfkcg.b[19][0]++;
        cov_2bjjvvfkcg.s[85]++;

        if (!getParent(e.target, "[data-id=".concat(this.selectId, "]"))) {
          cov_2bjjvvfkcg.b[20][0]++;
          cov_2bjjvvfkcg.s[86]++;
          this.blured = true;
          cov_2bjjvvfkcg.s[87]++;
          this.props.onBlur();
          cov_2bjjvvfkcg.s[88]++;

          if (this.element) {
            cov_2bjjvvfkcg.b[21][0]++;
            cov_2bjjvvfkcg.s[89]++;
            this.element.blur();
          } else {
            cov_2bjjvvfkcg.b[21][1]++;
          }
        } else {
          cov_2bjjvvfkcg.b[20][1]++;
        }

        cov_2bjjvvfkcg.s[90]++;
        this.handleState(false, null);
      } else {
        cov_2bjjvvfkcg.b[19][1]++;
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      cov_2bjjvvfkcg.f[20]++;

      var _ref5 = (cov_2bjjvvfkcg.s[91]++, this.props),
          onCreate = _ref5.onCreate,
          onFilter = _ref5.onFilter;

      var plain = (cov_2bjjvvfkcg.s[92]++, (cov_2bjjvvfkcg.b[22][0]++, !onCreate) && (cov_2bjjvvfkcg.b[22][1]++, !onFilter));
      var target = (cov_2bjjvvfkcg.s[93]++, e.target);
      cov_2bjjvvfkcg.s[94]++;

      if (this.focus) {
        cov_2bjjvvfkcg.b[23][0]++;
        cov_2bjjvvfkcg.s[95]++;

        if ((cov_2bjjvvfkcg.b[25][0]++, plain) && (cov_2bjjvvfkcg.b[25][1]++, isResult(target)) || (cov_2bjjvvfkcg.b[25][2]++, isResult(target, ".".concat(selectClass('caret'))))) {
          cov_2bjjvvfkcg.b[24][0]++;
          cov_2bjjvvfkcg.s[96]++;
          this.handleState(false, e);
          cov_2bjjvvfkcg.s[97]++;
          return;
        } else {
          cov_2bjjvvfkcg.b[24][1]++;
        }
      } else {
        cov_2bjjvvfkcg.b[23][1]++;
      }

      cov_2bjjvvfkcg.s[98]++;
      this.handleState(true, e);
    }
  }, {
    key: "handleState",
    value: function handleState(focus, e) {
      cov_2bjjvvfkcg.f[21]++;
      cov_2bjjvvfkcg.s[99]++;

      if (this.getDisabledStatus() === true) {
        cov_2bjjvvfkcg.b[26][0]++;
        cov_2bjjvvfkcg.s[100]++;
        return;
      } else {
        cov_2bjjvvfkcg.b[26][1]++;
      }

      cov_2bjjvvfkcg.s[101]++;

      if (focus === this.focus) {
        cov_2bjjvvfkcg.b[27][0]++;
        cov_2bjjvvfkcg.s[102]++;
        return;
      } else {
        cov_2bjjvvfkcg.b[27][1]++;
      } // click close icon


      cov_2bjjvvfkcg.s[103]++;

      if ((cov_2bjjvvfkcg.b[29][0]++, focus) && (cov_2bjjvvfkcg.b[29][1]++, e) && (cov_2bjjvvfkcg.b[29][2]++, e.target.classList.contains(selectClass('close')))) {
        cov_2bjjvvfkcg.b[28][0]++;
        cov_2bjjvvfkcg.s[104]++;
        return;
      } else {
        cov_2bjjvvfkcg.b[28][1]++;
      }

      var _ref6 = (cov_2bjjvvfkcg.s[105]++, this.props),
          _ref6$height = _ref6.height,
          height = _ref6$height === void 0 ? (cov_2bjjvvfkcg.b[30][0]++, DefaultValue.height) : _ref6$height,
          onCollapse = _ref6.onCollapse;

      var _ref7 = (cov_2bjjvvfkcg.s[106]++, this.props),
          position = _ref7.position;

      cov_2bjjvvfkcg.s[107]++;

      if (!position) {
        cov_2bjjvvfkcg.b[31][0]++;
        var windowHeight = (cov_2bjjvvfkcg.s[108]++, docSize.height);
        var rectElement = (cov_2bjjvvfkcg.s[109]++, (cov_2bjjvvfkcg.b[32][0]++, this.element.parentElement) || (cov_2bjjvvfkcg.b[32][1]++, this.element));
        var rect = (cov_2bjjvvfkcg.s[110]++, rectElement.getBoundingClientRect()); // 计算时要算上 marginTop/marginBottom 4

        var margin = (cov_2bjjvvfkcg.s[111]++, 4);
        var bottom = (cov_2bjjvvfkcg.s[112]++, height + rect.bottom + margin);
        var canDropUp = (cov_2bjjvvfkcg.s[113]++, rect.top > windowHeight - rect.bottom);
        cov_2bjjvvfkcg.s[114]++;

        if ((cov_2bjjvvfkcg.b[34][0]++, bottom > windowHeight) && (cov_2bjjvvfkcg.b[34][1]++, canDropUp)) {
          cov_2bjjvvfkcg.b[33][0]++;
          cov_2bjjvvfkcg.s[115]++;
          position = 'drop-up';
        } else {
          cov_2bjjvvfkcg.b[33][1]++;
        }
      } else {
        cov_2bjjvvfkcg.b[31][1]++;
      }

      cov_2bjjvvfkcg.s[116]++;

      if (onCollapse) {
        cov_2bjjvvfkcg.b[35][0]++;
        cov_2bjjvvfkcg.s[117]++;
        onCollapse(focus);
      } else {
        cov_2bjjvvfkcg.b[35][1]++;
      }

      cov_2bjjvvfkcg.s[118]++;
      this.setState({
        focus: focus,
        position: (cov_2bjjvvfkcg.b[36][0]++, position) || (cov_2bjjvvfkcg.b[36][1]++, 'drop-down')
      });
      cov_2bjjvvfkcg.s[119]++;

      if (focus) {
        cov_2bjjvvfkcg.b[37][0]++;
        cov_2bjjvvfkcg.s[120]++;
        this.blured = false;
        cov_2bjjvvfkcg.s[121]++;
        this.renderPending = false;
      } else {
        cov_2bjjvvfkcg.b[37][1]++;
      }
    }
  }, {
    key: "handleControlChange",
    value: function handleControlChange(control) {
      cov_2bjjvvfkcg.f[22]++;
      cov_2bjjvvfkcg.s[122]++;

      if (control !== this.state.control) {
        cov_2bjjvvfkcg.b[38][0]++;
        cov_2bjjvvfkcg.s[123]++;
        this.setState({
          control: control
        });
      } else {
        cov_2bjjvvfkcg.b[38][1]++;
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(_isActive, data, fromInput) {
      var _this2 = this;

      cov_2bjjvvfkcg.f[23]++;

      var _ref8 = (cov_2bjjvvfkcg.s[124]++, this.props),
          datum = _ref8.datum,
          multiple = _ref8.multiple,
          emptyAfterSelect = _ref8.emptyAfterSelect,
          onFilter = _ref8.onFilter,
          filterText = _ref8.filterText,
          onCreate = _ref8.onCreate,
          reFocus = _ref8.reFocus;

      cov_2bjjvvfkcg.s[125]++;

      if (this.getDisabledStatus() === true) {
        cov_2bjjvvfkcg.b[39][0]++;
        cov_2bjjvvfkcg.s[126]++;
        return;
      } else {
        cov_2bjjvvfkcg.b[39][1]++;
      } // if click option, ignore blur event


      cov_2bjjvvfkcg.s[127]++;

      if (this.inputBlurTimer) {
        cov_2bjjvvfkcg.b[40][0]++;
        cov_2bjjvvfkcg.s[128]++;
        this.lastChangeIsOptionClick = true;
        cov_2bjjvvfkcg.s[129]++;
        clearTimeout(this.inputBlurTimer);
        cov_2bjjvvfkcg.s[130]++;
        this.inputBlurTimer = null;
      } else {
        cov_2bjjvvfkcg.b[40][1]++;
      }

      var unMatchedData = (cov_2bjjvvfkcg.s[131]++, data);
      cov_2bjjvvfkcg.s[132]++;

      if (multiple) {
        cov_2bjjvvfkcg.b[41][0]++;
        cov_2bjjvvfkcg.s[133]++;

        if ((cov_2bjjvvfkcg.b[43][0]++, isObject(unMatchedData)) && (cov_2bjjvvfkcg.b[43][1]++, unMatchedData.IS_NOT_MATCHED_VALUE)) {
          cov_2bjjvvfkcg.b[42][0]++;
          cov_2bjjvvfkcg.s[134]++;
          datum.remove(unMatchedData);
        } else {
          cov_2bjjvvfkcg.b[42][1]++;
          var checked = (cov_2bjjvvfkcg.s[135]++, !datum.check(data));
          cov_2bjjvvfkcg.s[136]++;

          if (checked) {
            cov_2bjjvvfkcg.b[44][0]++;
            cov_2bjjvvfkcg.s[137]++;
            datum.add(data);
          } else {
            cov_2bjjvvfkcg.b[44][1]++;
            cov_2bjjvvfkcg.s[138]++;

            if (fromInput === true) {
              cov_2bjjvvfkcg.b[45][0]++;
              cov_2bjjvvfkcg.s[139]++;
              return;
            } else {
              cov_2bjjvvfkcg.b[45][1]++;
            }

            cov_2bjjvvfkcg.s[140]++;
            datum.remove(data);
          }

          cov_2bjjvvfkcg.s[141]++;

          if (this.inputReset) {
            cov_2bjjvvfkcg.b[46][0]++;
            cov_2bjjvvfkcg.s[142]++;
            this.inputReset();
          } else {
            cov_2bjjvvfkcg.b[46][1]++;
          }
        }
      } else {
        cov_2bjjvvfkcg.b[41][1]++;
        cov_2bjjvvfkcg.s[143]++;
        datum.set(data);
        cov_2bjjvvfkcg.s[144]++;

        if (!reFocus) {
          cov_2bjjvvfkcg.b[47][0]++;
          cov_2bjjvvfkcg.s[145]++;
          this.handleState(false);
        } else {
          cov_2bjjvvfkcg.b[47][1]++;
        } //  let the element focus


        cov_2bjjvvfkcg.s[146]++;
        setTimeout(function () {
          cov_2bjjvvfkcg.f[24]++;
          cov_2bjjvvfkcg.s[147]++;

          if ((cov_2bjjvvfkcg.b[49][0]++, reFocus) && (cov_2bjjvvfkcg.b[49][1]++, _this2.focusInput)) {
            cov_2bjjvvfkcg.b[48][0]++;
            cov_2bjjvvfkcg.s[148]++;

            _this2.focusInput(true);
          } else {
            cov_2bjjvvfkcg.b[48][1]++;
          }

          cov_2bjjvvfkcg.s[149]++;

          if ((cov_2bjjvvfkcg.b[51][0]++, onCreate) && (cov_2bjjvvfkcg.b[51][1]++, _this2.blured)) {
            cov_2bjjvvfkcg.b[50][0]++;
            cov_2bjjvvfkcg.s[150]++;
            return;
          } else {
            cov_2bjjvvfkcg.b[50][1]++;
          }

          cov_2bjjvvfkcg.s[151]++;

          if (_this2.element) {
            cov_2bjjvvfkcg.b[52][0]++;
            cov_2bjjvvfkcg.s[152]++;

            _this2.element.focus();
          } else {
            cov_2bjjvvfkcg.b[52][1]++;
          }
        }, 10);
      }

      cov_2bjjvvfkcg.s[153]++;

      if ((cov_2bjjvvfkcg.b[54][0]++, emptyAfterSelect) && (cov_2bjjvvfkcg.b[54][1]++, onFilter) && (cov_2bjjvvfkcg.b[54][2]++, filterText)) {
        cov_2bjjvvfkcg.b[53][0]++;
        cov_2bjjvvfkcg.s[154]++;
        onFilter('', 'select');
      } else {
        cov_2bjjvvfkcg.b[53][1]++;
      }
    } // toInputTriggerCollapse(text) {
    //   const { onCreate, datum } = this.props
    //   if (onCreate) {
    //     datum.set(onCreate(text))
    //   }
    //   this.handleState(true)
    // }

  }, {
    key: "shouldFocus",
    value: function shouldFocus(el) {
      cov_2bjjvvfkcg.f[25]++;
      cov_2bjjvvfkcg.s[155]++;

      if (el.getAttribute('data-id') === this.selectId) {
        cov_2bjjvvfkcg.b[55][0]++;
        cov_2bjjvvfkcg.s[156]++;
        return true;
      } else {
        cov_2bjjvvfkcg.b[55][1]++;
      }

      cov_2bjjvvfkcg.s[157]++;

      if (getParent(el, ".".concat(selectClass('result')))) {
        cov_2bjjvvfkcg.b[56][0]++;
        cov_2bjjvvfkcg.s[158]++;
        return true;
      } else {
        cov_2bjjvvfkcg.b[56][1]++;
      }

      cov_2bjjvvfkcg.s[159]++;
      return false;
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      cov_2bjjvvfkcg.f[26]++;
      cov_2bjjvvfkcg.s[160]++;

      if (!this.shouldFocus(e.target)) {
        cov_2bjjvvfkcg.b[57][0]++;
        cov_2bjjvvfkcg.s[161]++;
        return;
      } else {
        cov_2bjjvvfkcg.b[57][1]++;
      }

      cov_2bjjvvfkcg.s[162]++;
      this.props.onFocus(e);
    }
  }, {
    key: "handleInputFocus",
    value: function handleInputFocus() {
      cov_2bjjvvfkcg.f[27]++;

      var _ref9 = (cov_2bjjvvfkcg.s[163]++, this.props),
          hideCreateOption = _ref9.hideCreateOption,
          onCreate = _ref9.onCreate;

      cov_2bjjvvfkcg.s[164]++;
      this.inputLocked = true;
      var noHover = (cov_2bjjvvfkcg.s[165]++, (cov_2bjjvvfkcg.b[58][0]++, onCreate) && (cov_2bjjvvfkcg.b[58][1]++, hideCreateOption));
      cov_2bjjvvfkcg.s[166]++;

      if ((cov_2bjjvvfkcg.b[60][0]++, this.props.inputable) && (cov_2bjjvvfkcg.b[60][1]++, this.state.control === 'keyboard') && (cov_2bjjvvfkcg.b[60][2]++, !noHover)) {
        cov_2bjjvvfkcg.b[59][0]++;
        cov_2bjjvvfkcg.s[167]++;

        if (this.optionList.handleHover) {
          cov_2bjjvvfkcg.b[61][0]++;
          cov_2bjjvvfkcg.s[168]++;
          this.optionList.handleHover(0, true);
        } else {
          cov_2bjjvvfkcg.b[61][1]++;
        }
      } else {
        cov_2bjjvvfkcg.b[59][1]++;
      }
    }
  }, {
    key: "handleInputBlur",
    value: function handleInputBlur(text) {
      var _this3 = this;

      cov_2bjjvvfkcg.f[28]++;

      var _ref10 = (cov_2bjjvvfkcg.s[169]++, this.props),
          onFilter = _ref10.onFilter,
          onCreate = _ref10.onCreate,
          multiple = _ref10.multiple,
          filterSingleSelect = _ref10.filterSingleSelect,
          data = _ref10.data;

      cov_2bjjvvfkcg.s[170]++;

      if ((cov_2bjjvvfkcg.b[63][0]++, onFilter) && (cov_2bjjvvfkcg.b[63][1]++, text) && (cov_2bjjvvfkcg.b[63][2]++, filterSingleSelect) && (cov_2bjjvvfkcg.b[63][3]++, data.length === 1)) {
        cov_2bjjvvfkcg.b[62][0]++;
        cov_2bjjvvfkcg.s[171]++;
        this.handleChange(false, data[0], false);
        cov_2bjjvvfkcg.s[172]++;
        return;
      } else {
        cov_2bjjvvfkcg.b[62][1]++;
      }

      cov_2bjjvvfkcg.s[173]++;

      if (!onCreate) {
        cov_2bjjvvfkcg.b[64][0]++;
        cov_2bjjvvfkcg.s[174]++;
        return;
      } else {
        cov_2bjjvvfkcg.b[64][1]++;
      }

      cov_2bjjvvfkcg.s[175]++;

      if ((cov_2bjjvvfkcg.b[66][0]++, multiple) && (cov_2bjjvvfkcg.b[66][1]++, !text)) {
        cov_2bjjvvfkcg.b[65][0]++;
        cov_2bjjvvfkcg.s[176]++;
        return;
      } else {
        cov_2bjjvvfkcg.b[65][1]++;
      }

      cov_2bjjvvfkcg.s[177]++;

      if (this.lastChangeIsOptionClick) {
        cov_2bjjvvfkcg.b[67][0]++;
        cov_2bjjvvfkcg.s[178]++;
        return;
      } else {
        cov_2bjjvvfkcg.b[67][1]++;
      }

      cov_2bjjvvfkcg.s[179]++;

      this.blurHandler = function () {
        cov_2bjjvvfkcg.f[29]++;
        var retData = (cov_2bjjvvfkcg.s[180]++, onCreate(text));
        cov_2bjjvvfkcg.s[181]++;

        _this3.handleChange(false, retData, true);
      }; // if click option, ignore input blur


      cov_2bjjvvfkcg.s[182]++;
      this.inputBlurTimer = setTimeout(function () {
        cov_2bjjvvfkcg.f[30]++;
        cov_2bjjvvfkcg.s[183]++;

        if (_this3.blurHandler) {
          cov_2bjjvvfkcg.b[68][0]++;
          cov_2bjjvvfkcg.s[184]++;

          _this3.blurHandler();
        } else {
          cov_2bjjvvfkcg.b[68][1]++;
        }

        cov_2bjjvvfkcg.s[185]++;
        _this3.blurHandler = null;
      }, 200);
    }
  }, {
    key: "handleClear",
    value: function handleClear() {
      cov_2bjjvvfkcg.f[31]++;
      cov_2bjjvvfkcg.s[186]++;
      this.props.datum.setValue([]);
      cov_2bjjvvfkcg.s[187]++;
      this.element.focus();
      cov_2bjjvvfkcg.s[188]++;

      if (this.focus === false) {
        cov_2bjjvvfkcg.b[69][0]++;
        cov_2bjjvvfkcg.s[189]++;
        this.forceUpdate();
      } else {
        cov_2bjjvvfkcg.b[69][1]++;
        cov_2bjjvvfkcg.s[190]++;
        this.handleState(false);
      }
    }
  }, {
    key: "handleHideOption",
    value: function handleHideOption() {
      cov_2bjjvvfkcg.f[32]++;

      var _ref11 = (cov_2bjjvvfkcg.s[191]++, this.props),
          datum = _ref11.datum,
          innerData = _ref11.innerData;

      var checked = (cov_2bjjvvfkcg.s[192]++, datum.check(innerData));
      cov_2bjjvvfkcg.s[193]++;

      if (checked) {
        cov_2bjjvvfkcg.b[70][0]++;
        cov_2bjjvvfkcg.s[194]++;

        if (this.inputReset) {
          cov_2bjjvvfkcg.b[71][0]++;
          cov_2bjjvvfkcg.s[195]++;
          this.inputReset();
        } else {
          cov_2bjjvvfkcg.b[71][1]++;
        }

        cov_2bjjvvfkcg.s[196]++;
        return;
      } else {
        cov_2bjjvvfkcg.b[70][1]++;
      }

      cov_2bjjvvfkcg.s[197]++;
      this.handleChange(true, innerData);
    }
  }, {
    key: "handleEnter",
    value: function handleEnter() {
      cov_2bjjvvfkcg.f[33]++;

      var _ref12 = (cov_2bjjvvfkcg.s[198]++, this.props),
          onCreate = _ref12.onCreate,
          hideCreateOption = _ref12.hideCreateOption;

      var hoverIndex = (cov_2bjjvvfkcg.s[199]++, (cov_2bjjvvfkcg.b[72][0]++, this.optionList.getIndex) && (cov_2bjjvvfkcg.b[72][1]++, this.optionList.getIndex()));
      cov_2bjjvvfkcg.s[200]++;

      if ((cov_2bjjvvfkcg.b[74][0]++, onCreate) && (cov_2bjjvvfkcg.b[74][1]++, hideCreateOption) && (cov_2bjjvvfkcg.b[74][2]++, hoverIndex === -1)) {
        cov_2bjjvvfkcg.b[73][0]++;
        cov_2bjjvvfkcg.s[201]++;
        this.handleHideOption();
        cov_2bjjvvfkcg.s[202]++;
        return;
      } else {
        cov_2bjjvvfkcg.b[73][1]++;
      }

      var data = (cov_2bjjvvfkcg.s[203]++, this.props.data[hoverIndex]);
      cov_2bjjvvfkcg.s[204]++;

      if (!data) {
        cov_2bjjvvfkcg.b[75][0]++;
        cov_2bjjvvfkcg.s[205]++;
        // eslint-disable-next-line prefer-destructuring
        data = this.props.data[0];
      } else {
        cov_2bjjvvfkcg.b[75][1]++;
      }

      cov_2bjjvvfkcg.s[206]++;

      if ((cov_2bjjvvfkcg.b[77][0]++, data) && (cov_2bjjvvfkcg.b[77][1]++, !data[this.props.groupKey])) {
        cov_2bjjvvfkcg.b[76][0]++;
        var checked = (cov_2bjjvvfkcg.s[207]++, !this.props.datum.check(data));
        cov_2bjjvvfkcg.s[208]++;
        this.handleChange(checked, data);
        cov_2bjjvvfkcg.s[209]++;

        if (this.optionList.handleHover) {
          cov_2bjjvvfkcg.b[78][0]++;
          cov_2bjjvvfkcg.s[210]++;
          this.optionList.handleHover(hoverIndex);
        } else {
          cov_2bjjvvfkcg.b[78][1]++;
        }
      } else {
        cov_2bjjvvfkcg.b[76][1]++;
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      cov_2bjjvvfkcg.f[34]++;

      var _ref13 = (cov_2bjjvvfkcg.s[211]++, this.props),
          onEnterExpand = _ref13.onEnterExpand;

      cov_2bjjvvfkcg.s[212]++;
      this.keyLocked = true; // just for enter to open the list

      cov_2bjjvvfkcg.s[213]++;

      if (((cov_2bjjvvfkcg.b[80][0]++, e.keyCode === 13) || (cov_2bjjvvfkcg.b[80][1]++, e.keyCode === 40)) && (cov_2bjjvvfkcg.b[80][2]++, !this.focus)) {
        cov_2bjjvvfkcg.b[79][0]++;
        cov_2bjjvvfkcg.s[214]++;
        e.preventDefault();
        cov_2bjjvvfkcg.s[215]++;

        if (typeof onEnterExpand === 'function') {
          cov_2bjjvvfkcg.b[81][0]++;
          var canOpen = (cov_2bjjvvfkcg.s[216]++, onEnterExpand(e));
          cov_2bjjvvfkcg.s[217]++;

          if (canOpen === false) {
            cov_2bjjvvfkcg.b[82][0]++;
            cov_2bjjvvfkcg.s[218]++;
            return;
          } else {
            cov_2bjjvvfkcg.b[82][1]++;
          }
        } else {
          cov_2bjjvvfkcg.b[81][1]++;
        }

        cov_2bjjvvfkcg.s[219]++;
        this.handleClick(e);
        cov_2bjjvvfkcg.s[220]++;
        return;
      } else {
        cov_2bjjvvfkcg.b[79][1]++;
      } // fot close the list


      cov_2bjjvvfkcg.s[221]++;

      if (e.keyCode === 9) {
        cov_2bjjvvfkcg.b[83][0]++;
        cov_2bjjvvfkcg.s[222]++;
        this.props.onBlur(e); // e.preventDefault()

        cov_2bjjvvfkcg.s[223]++;

        if (this.focus) {
          cov_2bjjvvfkcg.b[84][0]++;
          cov_2bjjvvfkcg.s[224]++;
          this.handleState(false, e);
        } else {
          cov_2bjjvvfkcg.b[84][1]++;
          cov_2bjjvvfkcg.s[225]++;
          this.clearClickAway();
        }

        cov_2bjjvvfkcg.s[226]++;
        return;
      } else {
        cov_2bjjvvfkcg.b[83][1]++;
      } // no focus no event


      cov_2bjjvvfkcg.s[227]++;

      if (!this.focus) {
        cov_2bjjvvfkcg.b[85][0]++;
        cov_2bjjvvfkcg.s[228]++;
        return;
      } else {
        cov_2bjjvvfkcg.b[85][1]++;
      }

      cov_2bjjvvfkcg.s[229]++;
      this.handleControlChange('keyboard');
      cov_2bjjvvfkcg.s[230]++;

      switch (e.keyCode) {
        case 38:
          cov_2bjjvvfkcg.b[86][0]++;
          cov_2bjjvvfkcg.s[231]++;

          if (this.optionList.hoverMove) {
            cov_2bjjvvfkcg.b[87][0]++;
            cov_2bjjvvfkcg.s[232]++;
            this.optionList.hoverMove(-1);
          } else {
            cov_2bjjvvfkcg.b[87][1]++;
          }

          cov_2bjjvvfkcg.s[233]++;
          e.preventDefault();
          cov_2bjjvvfkcg.s[234]++;
          break;

        case 40:
          cov_2bjjvvfkcg.b[86][1]++;
          cov_2bjjvvfkcg.s[235]++;

          if (this.optionList.hoverMove) {
            cov_2bjjvvfkcg.b[88][0]++;
            cov_2bjjvvfkcg.s[236]++;
            this.optionList.hoverMove(1);
          } else {
            cov_2bjjvvfkcg.b[88][1]++;
          }

          cov_2bjjvvfkcg.s[237]++;
          e.preventDefault();
          cov_2bjjvvfkcg.s[238]++;
          break;

        case 13:
          cov_2bjjvvfkcg.b[86][2]++;
          cov_2bjjvvfkcg.s[239]++;
          this.handleEnter();
          cov_2bjjvvfkcg.s[240]++;
          e.preventDefault();
          cov_2bjjvvfkcg.s[241]++;
          e.stopPropagation();
          cov_2bjjvvfkcg.s[242]++;
          break;

        case 8:
          cov_2bjjvvfkcg.b[86][3]++;
          cov_2bjjvvfkcg.s[243]++;
          this.handleDelete(e);
          cov_2bjjvvfkcg.s[244]++;
          break;

        default:
          cov_2bjjvvfkcg.b[86][4]++;
          cov_2bjjvvfkcg.s[245]++;
          this.lastChangeIsOptionClick = false;
      }
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp() {
      cov_2bjjvvfkcg.f[35]++;
      cov_2bjjvvfkcg.s[246]++;
      this.keyLocked = false;
    }
  }, {
    key: "cancelDeleteLock",
    value: function cancelDeleteLock() {
      var _this4 = this;

      cov_2bjjvvfkcg.f[36]++;
      cov_2bjjvvfkcg.s[247]++;

      if (this.cancelDeleteLockTimer) {
        cov_2bjjvvfkcg.b[89][0]++;
        cov_2bjjvvfkcg.s[248]++;
        clearTimeout(this.cancelDeleteLockTimer);
      } else {
        cov_2bjjvvfkcg.b[89][1]++;
      }

      cov_2bjjvvfkcg.s[249]++;
      this.cancelDeleteLockTimer = setTimeout(function () {
        cov_2bjjvvfkcg.f[37]++;
        cov_2bjjvvfkcg.s[250]++;
        _this4.deleteLock = false;
      }, 400);
    }
  }, {
    key: "handleDelete",
    value: function handleDelete(e) {
      cov_2bjjvvfkcg.f[38]++;

      var _ref14 = (cov_2bjjvvfkcg.s[251]++, this.props),
          multiple = _ref14.multiple,
          inputText = _ref14.inputText,
          datum = _ref14.datum,
          value = _ref14.value,
          data = _ref14.data;

      cov_2bjjvvfkcg.s[252]++;

      if (!multiple) {
        cov_2bjjvvfkcg.b[90][0]++;
        cov_2bjjvvfkcg.s[253]++;
        return;
      } else {
        cov_2bjjvvfkcg.b[90][1]++;
      }

      cov_2bjjvvfkcg.s[254]++;

      if (inputText) {
        cov_2bjjvvfkcg.b[91][0]++;
        cov_2bjjvvfkcg.s[255]++;
        this.deleteLock = true;
      } else {
        cov_2bjjvvfkcg.b[91][1]++;
        cov_2bjjvvfkcg.s[256]++;

        if (this.deleteLock) {
          cov_2bjjvvfkcg.b[92][0]++;
          cov_2bjjvvfkcg.s[257]++;
          this.cancelDeleteLock();
        } else {
          cov_2bjjvvfkcg.b[92][1]++;
        }
      }

      cov_2bjjvvfkcg.s[258]++;

      if ((cov_2bjjvvfkcg.b[94][0]++, inputText) || (cov_2bjjvvfkcg.b[94][1]++, this.deleteLock)) {
        cov_2bjjvvfkcg.b[93][0]++;
        cov_2bjjvvfkcg.s[259]++;
        return;
      } else {
        cov_2bjjvvfkcg.b[93][1]++;
      }

      cov_2bjjvvfkcg.s[260]++;

      if ((cov_2bjjvvfkcg.b[96][0]++, !value) || (cov_2bjjvvfkcg.b[96][1]++, Array.isArray(value)) && (cov_2bjjvvfkcg.b[96][2]++, !value.length)) {
        cov_2bjjvvfkcg.b[95][0]++;
        cov_2bjjvvfkcg.s[261]++;
        return;
      } else {
        cov_2bjjvvfkcg.b[95][1]++;
      }

      cov_2bjjvvfkcg.s[262]++;
      e.preventDefault();
      var raws = (cov_2bjjvvfkcg.s[263]++, Array.isArray(value) ? (cov_2bjjvvfkcg.b[97][0]++, value) : (cov_2bjjvvfkcg.b[97][1]++, [value]));
      var values = (cov_2bjjvvfkcg.s[264]++, _toConsumableArray(raws));
      cov_2bjjvvfkcg.s[265]++;

      if (isFunc(datum.disabled)) {
        cov_2bjjvvfkcg.b[98][0]++;
        cov_2bjjvvfkcg.s[266]++;

        // find last deleteable value
        for (var i = values.length - 1; i >= 0; i--) {
          var item = (cov_2bjjvvfkcg.s[267]++, values[i]);
          cov_2bjjvvfkcg.s[268]++;

          if (!datum.disabled(datum.getDataByValue(data, item))) {
            cov_2bjjvvfkcg.b[99][0]++;
            cov_2bjjvvfkcg.s[269]++;
            values.splice(i, 1);
            cov_2bjjvvfkcg.s[270]++;
            datum.handleChange(values, datum.getDataByValue(data, item), false);
            cov_2bjjvvfkcg.s[271]++;
            return;
          } else {
            cov_2bjjvvfkcg.b[99][1]++;
          }
        }
      } else {
        cov_2bjjvvfkcg.b[98][1]++;
      }
    }
  }, {
    key: "handleFilter",
    value: function handleFilter() {
      cov_2bjjvvfkcg.f[39]++;

      var _ref15 = (cov_2bjjvvfkcg.s[272]++, this.props),
          onFilter = _ref15.onFilter,
          onCreate = _ref15.onCreate,
          hideCreateOption = _ref15.hideCreateOption;

      var hideCreate = (cov_2bjjvvfkcg.s[273]++, (cov_2bjjvvfkcg.b[100][0]++, onCreate) && (cov_2bjjvvfkcg.b[100][1]++, hideCreateOption));
      cov_2bjjvvfkcg.s[274]++;

      if ((cov_2bjjvvfkcg.b[102][0]++, onCreate) && (cov_2bjjvvfkcg.b[102][1]++, !hideCreateOption)) {
        cov_2bjjvvfkcg.b[101][0]++;
        cov_2bjjvvfkcg.s[275]++;

        // 创建选项的时候 选择第一个
        if (this.optionList.handleHover) {
          cov_2bjjvvfkcg.b[103][0]++;
          cov_2bjjvvfkcg.s[276]++;
          this.optionList.handleHover(0, true);
        } else {
          cov_2bjjvvfkcg.b[103][1]++;
        }
      } else {
        cov_2bjjvvfkcg.b[101][1]++;
      }

      cov_2bjjvvfkcg.s[277]++;

      if (hideCreate) {
        cov_2bjjvvfkcg.b[104][0]++;
        cov_2bjjvvfkcg.s[278]++;

        if (this.optionList.handleHover) {
          cov_2bjjvvfkcg.b[105][0]++;
          cov_2bjjvvfkcg.s[279]++;
          this.optionList.handleHover(-1, true);
        } else {
          cov_2bjjvvfkcg.b[105][1]++;
        }
      } else {
        cov_2bjjvvfkcg.b[104][1]++;
      }

      cov_2bjjvvfkcg.s[280]++;

      if (onFilter) {
        cov_2bjjvvfkcg.b[106][0]++;
        cov_2bjjvvfkcg.s[281]++;
        onFilter.apply(void 0, arguments);
      } else {
        cov_2bjjvvfkcg.b[106][1]++;
      }
    }
  }, {
    key: "renderItem",
    value: function renderItem(data, index) {
      cov_2bjjvvfkcg.f[40]++;

      var _ref16 = (cov_2bjjvvfkcg.s[282]++, this.props),
          renderItem = _ref16.renderItem;

      cov_2bjjvvfkcg.s[283]++;
      return typeof renderItem === 'function' ? (cov_2bjjvvfkcg.b[107][0]++, renderItem(data, index)) : (cov_2bjjvvfkcg.b[107][1]++, data[renderItem]);
    }
  }, {
    key: "renderResult",
    value: function renderResult(data, index) {
      cov_2bjjvvfkcg.f[41]++;

      var _ref17 = (cov_2bjjvvfkcg.s[284]++, this.props),
          renderResult = _ref17.renderResult;

      cov_2bjjvvfkcg.s[285]++;

      if (!renderResult) {
        cov_2bjjvvfkcg.b[108][0]++;
        cov_2bjjvvfkcg.s[286]++;
        return this.renderItem(data, index);
      } else {
        cov_2bjjvvfkcg.b[108][1]++;
      }

      cov_2bjjvvfkcg.s[287]++;
      return typeof renderResult === 'function' ? (cov_2bjjvvfkcg.b[109][0]++, renderResult(data, index)) : (cov_2bjjvvfkcg.b[109][1]++, data[renderResult]);
    }
    /**
     * custom options list header
     */

  }, {
    key: "renderCustomHeader",
    value: function renderCustomHeader() {
      cov_2bjjvvfkcg.f[42]++;

      var _ref18 = (cov_2bjjvvfkcg.s[288]++, this.props),
          header = _ref18.header;

      cov_2bjjvvfkcg.s[289]++;

      if (
      /*#__PURE__*/
      React.isValidElement(header)) {
        cov_2bjjvvfkcg.b[110][0]++;
        cov_2bjjvvfkcg.s[290]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: selectClass('custom-header'),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 563,
              columnNumber: 46
            }
          }, header)
        );
      } else {
        cov_2bjjvvfkcg.b[110][1]++;
      }

      cov_2bjjvvfkcg.s[291]++;
      return null;
    }
  }, {
    key: "renderTree",
    value: function renderTree() {
      cov_2bjjvvfkcg.f[43]++;

      var _ref19 = (cov_2bjjvvfkcg.s[292]++, this.state),
          position = _ref19.position;

      var _ref20 = (cov_2bjjvvfkcg.s[293]++, this.props),
          optionWidth = _ref20.optionWidth;

      var props = (cov_2bjjvvfkcg.s[294]++, {
        treeData: this.props.treeData,
        expanded: this.props.expanded,
        onExpand: this.props.onExpand,
        loader: this.props.loader,
        defaultExpanded: this.props.defaultExpanded,
        defaultExpandAll: this.props.defaultExpandAll,
        datum: this.props.datum,
        keygen: this.props.keygen,
        multiple: this.props.multiple,
        text: this.props.text,
        height: this.props.height,
        loading: this.props.loading,
        onFilter: this.props.onFilter,
        filterText: this.props.filterText,
        absolute: this.props.absolute,
        zIndex: this.props.zIndex,
        childrenKey: this.props.childrenKey,
        expandIcons: this.props.expandIcons,
        emptyText: this.props.emptyText,
        renderOptionList: this.props.renderOptionList,
        renderItem: this.renderItem
      });
      var style = (cov_2bjjvvfkcg.s[295]++, optionWidth ? (cov_2bjjvvfkcg.b[111][0]++, {
        width: optionWidth,
        display: 'block'
      }) : (cov_2bjjvvfkcg.b[111][1]++, {
        display: 'none'
      }));
      cov_2bjjvvfkcg.s[296]++;
      return (
        /*#__PURE__*/
        React.createElement(WrappedOptionTree, Object.assign({
          onChange: this.handleChange,
          parentElement: this.element,
          position: position,
          rootClass: selectClass(position, (cov_2bjjvvfkcg.b[112][0]++, isRTL()) && (cov_2bjjvvfkcg.b[112][1]++, 'rtl')),
          selectId: this.selectId,
          focus: this.focus,
          renderPending: this.renderPending,
          fixed: "min"
        }, props, {
          style: style,
          customHeader: this.renderCustomHeader(),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 595,
            columnNumber: 7
          }
        }))
      );
    }
  }, {
    key: "renderList",
    value: function renderList() {
      cov_2bjjvvfkcg.f[44]++;

      var _ref21 = (cov_2bjjvvfkcg.s[297]++, this.state),
          control = _ref21.control,
          position = _ref21.position;

      var _ref22 = (cov_2bjjvvfkcg.s[298]++, this.props),
          autoAdapt = _ref22.autoAdapt,
          value = _ref22.value,
          optionWidth = _ref22.optionWidth;

      var props = (cov_2bjjvvfkcg.s[299]++, {
        data: this.props.data,
        datum: this.props.datum,
        keygen: this.props.keygen,
        multiple: this.props.multiple,
        columns: this.props.columns,
        columnWidth: this.props.columnWidth,
        columnsTitle: this.props.columnsTitle,
        text: this.props.text,
        itemsInView: (cov_2bjjvvfkcg.b[113][0]++, this.props.itemsInView) || (cov_2bjjvvfkcg.b[113][1]++, DefaultValue.itemsInView),
        absolute: this.props.absolute,
        lineHeight: (cov_2bjjvvfkcg.b[114][0]++, this.props.lineHeight) || (cov_2bjjvvfkcg.b[114][1]++, DefaultValue.lineHeight),
        height: (cov_2bjjvvfkcg.b[115][0]++, this.props.height) || (cov_2bjjvvfkcg.b[115][1]++, DefaultValue.height),
        loading: this.props.loading,
        onFilter: this.props.onFilter,
        filterText: this.props.filterText,
        zIndex: this.props.zIndex,
        groupKey: this.props.groupKey,
        hideCreateOption: this.props.hideCreateOption,
        emptyText: this.props.emptyText,
        renderOptionList: this.props.renderOptionList
      });
      var style = (cov_2bjjvvfkcg.s[300]++, optionWidth ? (cov_2bjjvvfkcg.b[116][0]++, {
        width: optionWidth
      }) : (cov_2bjjvvfkcg.b[116][1]++, {}));
      cov_2bjjvvfkcg.s[301]++;

      if ((cov_2bjjvvfkcg.b[118][0]++, typeof props.columns === 'number') && (cov_2bjjvvfkcg.b[118][1]++, props.columns >= 1) || (cov_2bjjvvfkcg.b[118][2]++, props.columns === -1)) {
        cov_2bjjvvfkcg.b[117][0]++;
        cov_2bjjvvfkcg.s[302]++;
        return (
          /*#__PURE__*/
          React.createElement(WrappedBoxList, Object.assign({}, props, {
            columns: props.columns,
            style: style,
            rootClass: selectClass(position, (cov_2bjjvvfkcg.b[119][0]++, isRTL()) && (cov_2bjjvvfkcg.b[119][1]++, 'rtl')),
            autoClass: selectClass((cov_2bjjvvfkcg.b[120][0]++, autoAdapt) && (cov_2bjjvvfkcg.b[120][1]++, 'auto-adapt')),
            bindOptionFunc: this.bindOptionFunc,
            renderPending: this.renderPending,
            focus: this.focus,
            selectId: this.selectId,
            onChange: this.handleChange,
            renderItem: this.renderItem,
            parentElement: this.element,
            position: position,
            fixed: autoAdapt ? (cov_2bjjvvfkcg.b[121][0]++, 'min') : (cov_2bjjvvfkcg.b[121][1]++, true),
            value: value,
            customHeader: this.renderCustomHeader(),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 639,
              columnNumber: 9
            }
          }))
        );
      } else {
        cov_2bjjvvfkcg.b[117][1]++;
      }

      cov_2bjjvvfkcg.s[303]++;
      return (
        /*#__PURE__*/
        React.createElement(WrappedOptionList, Object.assign({}, props, {
          style: style,
          autoAdapt: autoAdapt,
          rootClass: selectClass(position, (cov_2bjjvvfkcg.b[122][0]++, isRTL()) && (cov_2bjjvvfkcg.b[122][1]++, 'rtl')),
          autoClass: selectClass((cov_2bjjvvfkcg.b[123][0]++, autoAdapt) && (cov_2bjjvvfkcg.b[123][1]++, 'auto-adapt')),
          bindOptionFunc: this.bindOptionFunc,
          renderPending: this.renderPending,
          focus: this.focus,
          control: control,
          selectId: this.selectId,
          onControlChange: this.handleControlChange,
          onChange: this.handleChange,
          renderItem: this.renderItem,
          parentElement: this.element,
          position: position,
          fixed: autoAdapt ? (cov_2bjjvvfkcg.b[124][0]++, 'min') : (cov_2bjjvvfkcg.b[124][1]++, true),
          value: value,
          customHeader: this.renderCustomHeader(),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 660,
            columnNumber: 7
          }
        }))
      );
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      cov_2bjjvvfkcg.f[45]++;

      var _ref23 = (cov_2bjjvvfkcg.s[304]++, this.props),
          treeData = _ref23.treeData;

      cov_2bjjvvfkcg.s[305]++;

      if (treeData) {
        cov_2bjjvvfkcg.b[125][0]++;
        cov_2bjjvvfkcg.s[306]++;
        return this.renderTree();
      } else {
        cov_2bjjvvfkcg.b[125][1]++;
      }

      cov_2bjjvvfkcg.s[307]++;
      return this.renderList();
    }
  }, {
    key: "render",
    value: function render() {
      cov_2bjjvvfkcg.f[46]++;

      var _ref24 = (cov_2bjjvvfkcg.s[308]++, this.props),
          placeholder = _ref24.placeholder,
          multiple = _ref24.multiple,
          clearable = _ref24.clearable,
          size = _ref24.size,
          datum = _ref24.datum,
          filterText = _ref24.filterText,
          onCreate = _ref24.onCreate,
          compressed = _ref24.compressed,
          compressedBound = _ref24.compressedBound,
          trim = _ref24.trim,
          renderUnmatched = _ref24.renderUnmatched,
          showArrow = _ref24.showArrow,
          compressedClassName = _ref24.compressedClassName,
          resultClassName = _ref24.resultClassName,
          maxLength = _ref24.maxLength,
          innerTitle = _ref24.innerTitle,
          keygen = _ref24.keygen,
          convertBr = _ref24.convertBr,
          _ref24$data = _ref24.data,
          data = _ref24$data === void 0 ? (cov_2bjjvvfkcg.b[126][0]++, DefaultValue.data) : _ref24$data,
          onFilter = _ref24.onFilter,
          treeData = _ref24.treeData;

      var disabled = (cov_2bjjvvfkcg.s[309]++, this.getDisabledStatus());
      var className = (cov_2bjjvvfkcg.s[310]++, selectClass('inner', size, (cov_2bjjvvfkcg.b[127][0]++, this.focus) && (cov_2bjjvvfkcg.b[127][1]++, 'focus'), this.state.position, (cov_2bjjvvfkcg.b[128][0]++, multiple) && (cov_2bjjvvfkcg.b[128][1]++, 'multiple'), (cov_2bjjvvfkcg.b[129][0]++, disabled === true) && (cov_2bjjvvfkcg.b[129][1]++, getDirectionClass('disabled')), (cov_2bjjvvfkcg.b[130][0]++, !trim) && (cov_2bjjvvfkcg.b[130][1]++, 'pre')));
      cov_2bjjvvfkcg.s[311]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          // eslint-disable-next-line
          tabIndex: disabled === true ? (cov_2bjjvvfkcg.b[131][0]++, -1) : (cov_2bjjvvfkcg.b[131][1]++, 0),
          ref: this.bindElement,
          className: className,
          "data-id": this.selectId,
          onFocus: this.handleFocus,
          onClick: this.handleClick,
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 724,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement(Result, {
          trim: trim,
          maxLength: maxLength,
          filterText: filterText,
          onClear: clearable ? (cov_2bjjvvfkcg.b[132][0]++, this.handleClear) : (cov_2bjjvvfkcg.b[132][1]++, undefined),
          onCreate: onCreate,
          onRemove: this.handleRemove,
          onFilter: onFilter ? (cov_2bjjvvfkcg.b[133][0]++, this.handleFilter) : (cov_2bjjvvfkcg.b[133][1]++, undefined),
          datum: datum,
          disabled: disabled,
          focus: this.focus,
          values: datum.values,
          getResultByValue: this.props.getResultByValue,
          multiple: multiple,
          placeholder: placeholder,
          renderResult: this.renderResult,
          renderUnmatched: renderUnmatched,
          onInputBlur: this.handleInputBlur,
          onInputFocus: this.handleInputFocus,
          setInputReset: this.setInputReset,
          bindFocusInputFunc: this.bindFocusInputFunc // collapse={this.toInputTriggerCollapse}
          ,
          compressed: compressed,
          compressedBound: compressedBound,
          showArrow: showArrow,
          focusSelected: this.getFocusSelected(),
          compressedClassName: compressedClassName,
          resultClassName: resultClassName,
          innerTitle: innerTitle,
          keygen: keygen,
          data: (cov_2bjjvvfkcg.b[134][0]++, treeData) || (cov_2bjjvvfkcg.b[134][1]++, data),
          convertBr: convertBr,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 735,
            columnNumber: 9
          }
        }), this.renderOptions())
      );
    }
  }, {
    key: "focus",
    get: function get() {
      cov_2bjjvvfkcg.f[7]++;
      cov_2bjjvvfkcg.s[50]++;

      if ('open' in this.props) {
        cov_2bjjvvfkcg.b[6][0]++;
        cov_2bjjvvfkcg.s[51]++;
        return !!this.props.open;
      } else {
        cov_2bjjvvfkcg.b[6][1]++;
      }

      cov_2bjjvvfkcg.s[52]++;
      return this.state.focus;
    }
  }]);

  return Select;
}(PureComponent);

Select.defaultProps = DefaultValue;
export default Select;